const nanchang={
    "type": "FeatureCollection",
    "features": [
      {
        "type": "Feature",
        "properties": {
          "adcode": 360102,
          "name": "东湖区",
          "center": [
            115.889675,
            28.682988
          ],
          "centroid": [
            115.920134,
            28.727108
          ],
          "childrenNum": 0,
          "level": "district",
          "parent": {
            "adcode": 360100
          },
          "subFeatureIndex": 0,
          "acroutes": [
            100000,
            360000,
            360100
          ]
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  115.868642,
                  28.667836
                ],
                [
                  115.877916,
                  28.673255
                ],
                [
                  115.88453,
                  28.675194
                ],
                [
                  115.887381,
                  28.674962
                ],
                [
                  115.895077,
                  28.675782
                ],
                [
                  115.898367,
                  28.674866
                ],
                [
                  115.903381,
                  28.675647
                ],
                [
                  115.903471,
                  28.672031
                ],
                [
                  115.905533,
                  28.672224
                ],
                [
                  115.905499,
                  28.673872
                ],
                [
                  115.919843,
                  28.674017
                ],
                [
                  115.927584,
                  28.674104
                ],
                [
                  115.926255,
                  28.683862
                ],
                [
                  115.927584,
                  28.687024
                ],
                [
                  115.930368,
                  28.689666
                ],
                [
                  115.928948,
                  28.69277
                ],
                [
                  115.925015,
                  28.691922
                ],
                [
                  115.923618,
                  28.693821
                ],
                [
                  115.925308,
                  28.695248
                ],
                [
                  115.927877,
                  28.69948
                ],
                [
                  115.930942,
                  28.701948
                ],
                [
                  115.93323,
                  28.702661
                ],
                [
                  115.932013,
                  28.710286
                ],
                [
                  115.931877,
                  28.714152
                ],
                [
                  115.935776,
                  28.719318
                ],
                [
                  115.93803,
                  28.723376
                ],
                [
                  115.943247,
                  28.725255
                ],
                [
                  115.942999,
                  28.727385
                ],
                [
                  115.937748,
                  28.726103
                ],
                [
                  115.932903,
                  28.732146
                ],
                [
                  115.937286,
                  28.735471
                ],
                [
                  115.939123,
                  28.740309
                ],
                [
                  115.944565,
                  28.747931
                ],
                [
                  115.952464,
                  28.755832
                ],
                [
                  115.955923,
                  28.757614
                ],
                [
                  115.962639,
                  28.759917
                ],
                [
                  115.966864,
                  28.762345
                ],
                [
                  115.972566,
                  28.768039
                ],
                [
                  115.979687,
                  28.77669
                ],
                [
                  115.982189,
                  28.778202
                ],
                [
                  115.985558,
                  28.778819
                ],
                [
                  115.985073,
                  28.781535
                ],
                [
                  115.982673,
                  28.787401
                ],
                [
                  115.975101,
                  28.787498
                ],
                [
                  115.968543,
                  28.786872
                ],
                [
                  115.968183,
                  28.791225
                ],
                [
                  115.961129,
                  28.793296
                ],
                [
                  115.959641,
                  28.792612
                ],
                [
                  115.958267,
                  28.792294
                ],
                [
                  115.956363,
                  28.788731
                ],
                [
                  115.952013,
                  28.783876
                ],
                [
                  115.952779,
                  28.78062
                ],
                [
                  115.95065,
                  28.779137
                ],
                [
                  115.945162,
                  28.777046
                ],
                [
                  115.939235,
                  28.773569
                ],
                [
                  115.932892,
                  28.770486
                ],
                [
                  115.92612,
                  28.768781
                ],
                [
                  115.924824,
                  28.768453
                ],
                [
                  115.931551,
                  28.762075
                ],
                [
                  115.93572,
                  28.758655
                ],
                [
                  115.933151,
                  28.753934
                ],
                [
                  115.930537,
                  28.751862
                ],
                [
                  115.924373,
                  28.751795
                ],
                [
                  115.918209,
                  28.75006
                ],
                [
                  115.915235,
                  28.756506
                ],
                [
                  115.912497,
                  28.757595
                ],
                [
                  115.910818,
                  28.762788
                ],
                [
                  115.906942,
                  28.760659
                ],
                [
                  115.902547,
                  28.755996
                ],
                [
                  115.897657,
                  28.754647
                ],
                [
                  115.889814,
                  28.744606
                ],
                [
                  115.892316,
                  28.735538
                ],
                [
                  115.89306,
                  28.725631
                ],
                [
                  115.891674,
                  28.719627
                ],
                [
                  115.889578,
                  28.715434
                ],
                [
                  115.888879,
                  28.712137
                ],
                [
                  115.882704,
                  28.701081
                ],
                [
                  115.877104,
                  28.693995
                ],
                [
                  115.873994,
                  28.687776
                ],
                [
                  115.868642,
                  28.667836
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "adcode": 360103,
          "name": "西湖区",
          "center": [
            115.91065,
            28.662901
          ],
          "centroid": [
            115.876282,
            28.641821
          ],
          "childrenNum": 0,
          "level": "district",
          "parent": {
            "adcode": 360100
          },
          "subFeatureIndex": 1,
          "acroutes": [
            100000,
            360000,
            360100
          ]
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  115.832923,
                  28.617149
                ],
                [
                  115.839481,
                  28.614795
                ],
                [
                  115.843334,
                  28.61409
                ],
                [
                  115.845757,
                  28.609797
                ],
                [
                  115.848777,
                  28.608716
                ],
                [
                  115.854602,
                  28.612662
                ],
                [
                  115.861555,
                  28.614274
                ],
                [
                  115.86347,
                  28.611562
                ],
                [
                  115.868912,
                  28.609816
                ],
                [
                  115.87102,
                  28.610675
                ],
                [
                  115.87671,
                  28.609334
                ],
                [
                  115.880744,
                  28.609092
                ],
                [
                  115.884496,
                  28.607761
                ],
                [
                  115.887888,
                  28.610414
                ],
                [
                  115.885916,
                  28.611437
                ],
                [
                  115.885206,
                  28.614843
                ],
                [
                  115.891471,
                  28.621288
                ],
                [
                  115.89164,
                  28.624915
                ],
                [
                  115.893274,
                  28.626979
                ],
                [
                  115.893014,
                  28.634031
                ],
                [
                  115.891933,
                  28.636298
                ],
                [
                  115.892992,
                  28.637455
                ],
                [
                  115.897195,
                  28.637349
                ],
                [
                  115.898817,
                  28.638217
                ],
                [
                  115.90026,
                  28.641111
                ],
                [
                  115.900125,
                  28.645471
                ],
                [
                  115.898029,
                  28.654962
                ],
                [
                  115.91901,
                  28.654971
                ],
                [
                  115.919843,
                  28.674017
                ],
                [
                  115.905499,
                  28.673872
                ],
                [
                  115.905533,
                  28.672224
                ],
                [
                  115.903471,
                  28.672031
                ],
                [
                  115.903381,
                  28.675647
                ],
                [
                  115.898367,
                  28.674866
                ],
                [
                  115.895077,
                  28.675782
                ],
                [
                  115.887381,
                  28.674962
                ],
                [
                  115.88453,
                  28.675194
                ],
                [
                  115.877916,
                  28.673255
                ],
                [
                  115.868642,
                  28.667836
                ],
                [
                  115.86898,
                  28.662908
                ],
                [
                  115.866332,
                  28.657266
                ],
                [
                  115.85734,
                  28.64877
                ],
                [
                  115.854456,
                  28.646436
                ],
                [
                  115.847898,
                  28.643706
                ],
                [
                  115.844089,
                  28.640195
                ],
                [
                  115.842016,
                  28.635401
                ],
                [
                  115.835334,
                  28.626622
                ],
                [
                  115.833069,
                  28.621529
                ],
                [
                  115.832923,
                  28.617149
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "adcode": 360104,
          "name": "青云谱区",
          "center": [
            115.907292,
            28.635724
          ],
          "centroid": [
            115.920791,
            28.622914
          ],
          "childrenNum": 0,
          "level": "district",
          "parent": {
            "adcode": 360100
          },
          "subFeatureIndex": 2,
          "acroutes": [
            100000,
            360000,
            360100
          ]
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  115.91901,
                  28.654971
                ],
                [
                  115.898029,
                  28.654962
                ],
                [
                  115.900125,
                  28.645471
                ],
                [
                  115.90026,
                  28.641111
                ],
                [
                  115.898817,
                  28.638217
                ],
                [
                  115.897195,
                  28.637349
                ],
                [
                  115.892992,
                  28.637455
                ],
                [
                  115.891933,
                  28.636298
                ],
                [
                  115.893014,
                  28.634031
                ],
                [
                  115.893274,
                  28.626979
                ],
                [
                  115.89164,
                  28.624915
                ],
                [
                  115.891471,
                  28.621288
                ],
                [
                  115.885206,
                  28.614843
                ],
                [
                  115.885916,
                  28.611437
                ],
                [
                  115.887888,
                  28.610414
                ],
                [
                  115.890029,
                  28.607867
                ],
                [
                  115.89075,
                  28.604335
                ],
                [
                  115.892823,
                  28.603863
                ],
                [
                  115.891234,
                  28.60256
                ],
                [
                  115.891471,
                  28.599665
                ],
                [
                  115.895899,
                  28.597156
                ],
                [
                  115.900237,
                  28.593943
                ],
                [
                  115.903854,
                  28.59374
                ],
                [
                  115.904542,
                  28.591106
                ],
                [
                  115.903742,
                  28.583134
                ],
                [
                  115.906761,
                  28.583964
                ],
                [
                  115.909263,
                  28.583289
                ],
                [
                  115.910367,
                  28.587419
                ],
                [
                  115.912215,
                  28.587217
                ],
                [
                  115.912947,
                  28.589398
                ],
                [
                  115.914987,
                  28.590073
                ],
                [
                  115.914942,
                  28.59291
                ],
                [
                  115.918964,
                  28.59376
                ],
                [
                  115.922255,
                  28.597562
                ],
                [
                  115.925455,
                  28.597137
                ],
                [
                  115.928666,
                  28.594059
                ],
                [
                  115.937489,
                  28.592631
                ],
                [
                  115.937466,
                  28.593412
                ],
                [
                  115.93928,
                  28.596278
                ],
                [
                  115.93768,
                  28.597349
                ],
                [
                  115.938413,
                  28.601122
                ],
                [
                  115.942199,
                  28.602058
                ],
                [
                  115.946233,
                  28.605532
                ],
                [
                  115.947067,
                  28.608513
                ],
                [
                  115.944847,
                  28.611659
                ],
                [
                  115.954954,
                  28.613019
                ],
                [
                  115.955777,
                  28.614717
                ],
                [
                  115.956137,
                  28.634012
                ],
                [
                  115.954019,
                  28.636308
                ],
                [
                  115.95385,
                  28.639028
                ],
                [
                  115.942402,
                  28.639684
                ],
                [
                  115.945478,
                  28.645452
                ],
                [
                  115.943224,
                  28.645809
                ],
                [
                  115.944858,
                  28.649869
                ],
                [
                  115.936959,
                  28.653283
                ],
                [
                  115.930266,
                  28.654711
                ],
                [
                  115.91901,
                  28.654971
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "adcode": 360111,
          "name": "青山湖区",
          "center": [
            115.949044,
            28.689292
          ],
          "centroid": [
            115.835289,
            28.756539
          ],
          "childrenNum": 0,
          "level": "district",
          "parent": {
            "adcode": 360100
          },
          "subFeatureIndex": 3,
          "acroutes": [
            100000,
            360000,
            360100
          ]
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  115.92612,
                  28.768781
                ],
                [
                  115.926379,
                  28.776121
                ],
                [
                  115.927201,
                  28.778588
                ],
                [
                  115.924317,
                  28.779098
                ],
                [
                  115.921229,
                  28.78194
                ],
                [
                  115.919133,
                  28.780639
                ],
                [
                  115.911235,
                  28.782277
                ],
                [
                  115.909544,
                  28.787421
                ],
                [
                  115.909443,
                  28.789723
                ],
                [
                  115.911133,
                  28.791476
                ],
                [
                  115.910581,
                  28.794221
                ],
                [
                  115.90231,
                  28.793941
                ],
                [
                  115.899268,
                  28.795251
                ],
                [
                  115.898784,
                  28.800096
                ],
                [
                  115.889645,
                  28.80936
                ],
                [
                  115.885995,
                  28.808137
                ],
                [
                  115.882411,
                  28.805431
                ],
                [
                  115.877206,
                  28.806587
                ],
                [
                  115.874073,
                  28.804372
                ],
                [
                  115.868845,
                  28.805595
                ],
                [
                  115.867391,
                  28.805104
                ],
                [
                  115.868067,
                  28.801579
                ],
                [
                  115.87102,
                  28.80078
                ],
                [
                  115.871155,
                  28.797601
                ],
                [
                  115.868912,
                  28.79606
                ],
                [
                  115.86862,
                  28.794279
                ],
                [
                  115.864721,
                  28.793508
                ],
                [
                  115.859188,
                  28.797178
                ],
                [
                  115.858569,
                  28.799961
                ],
                [
                  115.855864,
                  28.798805
                ],
                [
                  115.853678,
                  28.793691
                ],
                [
                  115.850129,
                  28.793835
                ],
                [
                  115.842613,
                  28.796619
                ],
                [
                  115.839244,
                  28.799162
                ],
                [
                  115.838624,
                  28.801155
                ],
                [
                  115.833261,
                  28.803842
                ],
                [
                  115.828799,
                  28.802523
                ],
                [
                  115.827751,
                  28.807434
                ],
                [
                  115.828483,
                  28.809929
                ],
                [
                  115.833813,
                  28.815774
                ],
                [
                  115.835233,
                  28.819838
                ],
                [
                  115.83183,
                  28.8208
                ],
                [
                  115.829914,
                  28.819414
                ],
                [
                  115.826297,
                  28.820935
                ],
                [
                  115.821261,
                  28.813954
                ],
                [
                  115.816945,
                  28.812095
                ],
                [
                  115.813373,
                  28.811816
                ],
                [
                  115.811379,
                  28.813492
                ],
                [
                  115.80908,
                  28.812221
                ],
                [
                  115.807198,
                  28.809553
                ],
                [
                  115.809497,
                  28.807993
                ],
                [
                  115.813362,
                  28.806866
                ],
                [
                  115.816663,
                  28.80676
                ],
                [
                  115.817441,
                  28.803669
                ],
                [
                  115.813182,
                  28.800587
                ],
                [
                  115.807987,
                  28.799951
                ],
                [
                  115.804731,
                  28.796975
                ],
                [
                  115.805846,
                  28.795194
                ],
                [
                  115.811018,
                  28.792969
                ],
                [
                  115.806274,
                  28.788133
                ],
                [
                  115.796404,
                  28.787064
                ],
                [
                  115.788674,
                  28.783828
                ],
                [
                  115.782409,
                  28.784358
                ],
                [
                  115.775119,
                  28.781121
                ],
                [
                  115.771727,
                  28.774349
                ],
                [
                  115.7658,
                  28.770476
                ],
                [
                  115.766859,
                  28.767114
                ],
                [
                  115.764347,
                  28.767056
                ],
                [
                  115.763355,
                  28.764888
                ],
                [
                  115.764617,
                  28.762798
                ],
                [
                  115.762138,
                  28.760996
                ],
                [
                  115.759975,
                  28.761227
                ],
                [
                  115.757056,
                  28.75825
                ],
                [
                  115.7538,
                  28.759618
                ],
                [
                  115.755614,
                  28.756844
                ],
                [
                  115.753834,
                  28.753934
                ],
                [
                  115.753338,
                  28.749434
                ],
                [
                  115.754386,
                  28.746832
                ],
                [
                  115.753563,
                  28.744953
                ],
                [
                  115.756493,
                  28.742544
                ],
                [
                  115.759377,
                  28.741889
                ],
                [
                  115.756087,
                  28.737032
                ],
                [
                  115.761406,
                  28.730508
                ],
                [
                  115.764966,
                  28.725361
                ],
                [
                  115.769744,
                  28.723202
                ],
                [
                  115.771659,
                  28.719848
                ],
                [
                  115.76998,
                  28.719675
                ],
                [
                  115.769913,
                  28.715222
                ],
                [
                  115.771704,
                  28.71286
                ],
                [
                  115.771547,
                  28.710402
                ],
                [
                  115.774657,
                  28.710103
                ],
                [
                  115.776505,
                  28.70726
                ],
                [
                  115.780899,
                  28.702951
                ],
                [
                  115.785113,
                  28.701987
                ],
                [
                  115.786296,
                  28.704609
                ],
                [
                  115.783592,
                  28.706479
                ],
                [
                  115.78384,
                  28.70993
                ],
                [
                  115.793406,
                  28.706228
                ],
                [
                  115.794139,
                  28.708657
                ],
                [
                  115.804212,
                  28.70832
                ],
                [
                  115.807987,
                  28.707211
                ],
                [
                  115.81015,
                  28.705525
                ],
                [
                  115.813497,
                  28.704522
                ],
                [
                  115.818128,
                  28.700743
                ],
                [
                  115.820089,
                  28.700338
                ],
                [
                  115.821734,
                  28.703924
                ],
                [
                  115.823728,
                  28.703346
                ],
                [
                  115.828573,
                  28.699702
                ],
                [
                  115.831345,
                  28.699095
                ],
                [
                  115.831796,
                  28.697784
                ],
                [
                  115.836495,
                  28.696974
                ],
                [
                  115.839627,
                  28.695219
                ],
                [
                  115.843548,
                  28.694284
                ],
                [
                  115.844934,
                  28.697244
                ],
                [
                  115.846298,
                  28.703095
                ],
                [
                  115.84952,
                  28.703732
                ],
                [
                  115.852698,
                  28.705766
                ],
                [
                  115.855763,
                  28.706681
                ],
                [
                  115.861138,
                  28.705688
                ],
                [
                  115.85218,
                  28.713737
                ],
                [
                  115.848878,
                  28.718229
                ],
                [
                  115.849442,
                  28.72193
                ],
                [
                  115.852157,
                  28.72006
                ],
                [
                  115.853306,
                  28.721766
                ],
                [
                  115.855785,
                  28.722383
                ],
                [
                  115.855346,
                  28.729004
                ],
                [
                  115.862884,
                  28.729101
                ],
                [
                  115.860732,
                  28.727048
                ],
                [
                  115.863436,
                  28.725853
                ],
                [
                  115.865814,
                  28.728657
                ],
                [
                  115.865994,
                  28.733071
                ],
                [
                  115.864033,
                  28.731259
                ],
                [
                  115.864631,
                  28.734372
                ],
                [
                  115.866896,
                  28.735847
                ],
                [
                  115.86551,
                  28.738391
                ],
                [
                  115.866084,
                  28.743373
                ],
                [
                  115.867831,
                  28.732801
                ],
                [
                  115.870298,
                  28.733592
                ],
                [
                  115.873352,
                  28.731616
                ],
                [
                  115.871955,
                  28.730084
                ],
                [
                  115.874231,
                  28.728397
                ],
                [
                  115.876507,
                  28.73098
                ],
                [
                  115.878434,
                  28.730248
                ],
                [
                  115.880789,
                  28.735375
                ],
                [
                  115.883178,
                  28.73628
                ],
                [
                  115.88649,
                  28.739682
                ],
                [
                  115.889814,
                  28.744606
                ],
                [
                  115.897657,
                  28.754647
                ],
                [
                  115.902547,
                  28.755996
                ],
                [
                  115.906942,
                  28.760659
                ],
                [
                  115.910818,
                  28.762788
                ],
                [
                  115.912497,
                  28.757595
                ],
                [
                  115.915235,
                  28.756506
                ],
                [
                  115.918209,
                  28.75006
                ],
                [
                  115.924373,
                  28.751795
                ],
                [
                  115.930537,
                  28.751862
                ],
                [
                  115.933151,
                  28.753934
                ],
                [
                  115.93572,
                  28.758655
                ],
                [
                  115.931551,
                  28.762075
                ],
                [
                  115.924824,
                  28.768453
                ],
                [
                  115.92612,
                  28.768781
                ]
              ]
            ],
            [
              [
                [
                  115.937466,
                  28.593412
                ],
                [
                  115.940914,
                  28.59098
                ],
                [
                  115.94603,
                  28.591424
                ],
                [
                  115.953613,
                  28.594252
                ],
                [
                  115.955709,
                  28.59569
                ],
                [
                  115.95936,
                  28.593846
                ],
                [
                  115.960734,
                  28.591212
                ],
                [
                  115.965219,
                  28.590565
                ],
                [
                  115.967078,
                  28.588085
                ],
                [
                  115.969861,
                  28.587236
                ],
                [
                  115.972554,
                  28.588375
                ],
                [
                  115.976048,
                  28.587593
                ],
                [
                  115.977411,
                  28.585258
                ],
                [
                  115.98158,
                  28.585238
                ],
                [
                  115.983642,
                  28.58739
                ],
                [
                  115.984138,
                  28.589948
                ],
                [
                  115.989434,
                  28.589793
                ],
                [
                  115.992769,
                  28.588413
                ],
                [
                  115.995902,
                  28.585702
                ],
                [
                  115.999789,
                  28.586763
                ],
                [
                  116.000138,
                  28.588037
                ],
                [
                  116.003947,
                  28.589253
                ],
                [
                  116.00353,
                  28.5874
                ],
                [
                  116.005254,
                  28.583935
                ],
                [
                  116.009355,
                  28.582797
                ],
                [
                  116.017705,
                  28.585721
                ],
                [
                  116.020229,
                  28.589349
                ],
                [
                  116.024522,
                  28.592582
                ],
                [
                  116.033446,
                  28.598266
                ],
                [
                  116.040534,
                  28.599578
                ],
                [
                  116.041221,
                  28.600823
                ],
                [
                  116.041953,
                  28.607404
                ],
                [
                  116.043914,
                  28.609411
                ],
                [
                  116.048185,
                  28.610337
                ],
                [
                  116.05179,
                  28.616271
                ],
                [
                  116.052297,
                  28.619599
                ],
                [
                  116.055227,
                  28.621963
                ],
                [
                  116.054404,
                  28.625224
                ],
                [
                  116.055757,
                  28.627394
                ],
                [
                  116.052838,
                  28.631619
                ],
                [
                  116.046224,
                  28.635391
                ],
                [
                  116.044737,
                  28.637996
                ],
                [
                  116.04441,
                  28.647718
                ],
                [
                  116.045063,
                  28.655579
                ],
                [
                  116.037773,
                  28.648885
                ],
                [
                  116.035238,
                  28.643513
                ],
                [
                  116.030933,
                  28.641015
                ],
                [
                  116.026449,
                  28.639973
                ],
                [
                  116.019812,
                  28.642384
                ],
                [
                  116.015981,
                  28.647564
                ],
                [
                  116.012353,
                  28.650178
                ],
                [
                  116.00895,
                  28.654016
                ],
                [
                  116.005198,
                  28.660555
                ],
                [
                  116.005389,
                  28.661809
                ],
                [
                  116.000375,
                  28.662764
                ],
                [
                  115.995496,
                  28.66447
                ],
                [
                  115.996792,
                  28.670748
                ],
                [
                  115.998876,
                  28.676042
                ],
                [
                  116.003868,
                  28.682107
                ],
                [
                  116.006572,
                  28.690177
                ],
                [
                  116.006775,
                  28.69251
                ],
                [
                  116.010313,
                  28.694486
                ],
                [
                  116.01517,
                  28.699181
                ],
                [
                  116.015226,
                  28.700454
                ],
                [
                  116.01126,
                  28.701534
                ],
                [
                  116.011586,
                  28.704561
                ],
                [
                  116.013806,
                  28.707433
                ],
                [
                  116.015046,
                  28.711347
                ],
                [
                  116.017175,
                  28.713689
                ],
                [
                  116.022099,
                  28.717198
                ],
                [
                  116.027395,
                  28.718961
                ],
                [
                  116.028207,
                  28.721053
                ],
                [
                  116.023542,
                  28.720002
                ],
                [
                  116.022347,
                  28.721063
                ],
                [
                  116.022494,
                  28.72432
                ],
                [
                  116.016522,
                  28.723617
                ],
                [
                  116.010933,
                  28.724908
                ],
                [
                  116.002617,
                  28.725564
                ],
                [
                  115.997761,
                  28.7254
                ],
                [
                  115.981073,
                  28.73072
                ],
                [
                  115.97474,
                  28.733293
                ],
                [
                  115.968115,
                  28.734449
                ],
                [
                  115.959574,
                  28.734247
                ],
                [
                  115.953816,
                  28.732667
                ],
                [
                  115.947393,
                  28.729901
                ],
                [
                  115.942999,
                  28.727385
                ],
                [
                  115.943247,
                  28.725255
                ],
                [
                  115.93803,
                  28.723376
                ],
                [
                  115.935776,
                  28.719318
                ],
                [
                  115.931877,
                  28.714152
                ],
                [
                  115.932013,
                  28.710286
                ],
                [
                  115.93323,
                  28.702661
                ],
                [
                  115.930942,
                  28.701948
                ],
                [
                  115.927877,
                  28.69948
                ],
                [
                  115.925308,
                  28.695248
                ],
                [
                  115.923618,
                  28.693821
                ],
                [
                  115.925015,
                  28.691922
                ],
                [
                  115.928948,
                  28.69277
                ],
                [
                  115.930368,
                  28.689666
                ],
                [
                  115.927584,
                  28.687024
                ],
                [
                  115.926255,
                  28.683862
                ],
                [
                  115.927584,
                  28.674104
                ],
                [
                  115.919843,
                  28.674017
                ],
                [
                  115.91901,
                  28.654971
                ],
                [
                  115.930266,
                  28.654711
                ],
                [
                  115.936959,
                  28.653283
                ],
                [
                  115.944858,
                  28.649869
                ],
                [
                  115.943224,
                  28.645809
                ],
                [
                  115.945478,
                  28.645452
                ],
                [
                  115.942402,
                  28.639684
                ],
                [
                  115.95385,
                  28.639028
                ],
                [
                  115.954019,
                  28.636308
                ],
                [
                  115.956137,
                  28.634012
                ],
                [
                  115.955777,
                  28.614717
                ],
                [
                  115.954954,
                  28.613019
                ],
                [
                  115.944847,
                  28.611659
                ],
                [
                  115.947067,
                  28.608513
                ],
                [
                  115.946233,
                  28.605532
                ],
                [
                  115.942199,
                  28.602058
                ],
                [
                  115.938413,
                  28.601122
                ],
                [
                  115.93768,
                  28.597349
                ],
                [
                  115.93928,
                  28.596278
                ],
                [
                  115.937466,
                  28.593412
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "adcode": 360112,
          "name": "新建区",
          "center": [
            115.820806,
            28.690788
          ],
          "centroid": [
            115.912716,
            28.798554
          ],
          "childrenNum": 0,
          "level": "district",
          "parent": {
            "adcode": 360100
          },
          "subFeatureIndex": 4,
          "acroutes": [
            100000,
            360000,
            360100
          ]
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  115.843548,
                  28.694284
                ],
                [
                  115.839627,
                  28.695219
                ],
                [
                  115.836495,
                  28.696974
                ],
                [
                  115.831796,
                  28.697784
                ],
                [
                  115.831345,
                  28.699095
                ],
                [
                  115.828573,
                  28.699702
                ],
                [
                  115.823728,
                  28.703346
                ],
                [
                  115.821734,
                  28.703924
                ],
                [
                  115.820089,
                  28.700338
                ],
                [
                  115.818128,
                  28.700743
                ],
                [
                  115.813497,
                  28.704522
                ],
                [
                  115.81015,
                  28.705525
                ],
                [
                  115.807987,
                  28.707211
                ],
                [
                  115.804212,
                  28.70832
                ],
                [
                  115.794139,
                  28.708657
                ],
                [
                  115.793406,
                  28.706228
                ],
                [
                  115.78384,
                  28.70993
                ],
                [
                  115.783592,
                  28.706479
                ],
                [
                  115.786296,
                  28.704609
                ],
                [
                  115.785113,
                  28.701987
                ],
                [
                  115.780899,
                  28.702951
                ],
                [
                  115.776505,
                  28.70726
                ],
                [
                  115.774657,
                  28.710103
                ],
                [
                  115.771547,
                  28.710402
                ],
                [
                  115.771704,
                  28.71286
                ],
                [
                  115.769913,
                  28.715222
                ],
                [
                  115.76998,
                  28.719675
                ],
                [
                  115.771659,
                  28.719848
                ],
                [
                  115.769744,
                  28.723202
                ],
                [
                  115.764966,
                  28.725361
                ],
                [
                  115.761406,
                  28.730508
                ],
                [
                  115.756087,
                  28.737032
                ],
                [
                  115.759377,
                  28.741889
                ],
                [
                  115.756493,
                  28.742544
                ],
                [
                  115.753563,
                  28.744953
                ],
                [
                  115.754386,
                  28.746832
                ],
                [
                  115.753338,
                  28.749434
                ],
                [
                  115.753834,
                  28.753934
                ],
                [
                  115.755614,
                  28.756844
                ],
                [
                  115.7538,
                  28.759618
                ],
                [
                  115.757056,
                  28.75825
                ],
                [
                  115.759975,
                  28.761227
                ],
                [
                  115.762138,
                  28.760996
                ],
                [
                  115.764617,
                  28.762798
                ],
                [
                  115.763355,
                  28.764888
                ],
                [
                  115.764347,
                  28.767056
                ],
                [
                  115.766859,
                  28.767114
                ],
                [
                  115.7658,
                  28.770476
                ],
                [
                  115.771727,
                  28.774349
                ],
                [
                  115.775119,
                  28.781121
                ],
                [
                  115.782409,
                  28.784358
                ],
                [
                  115.788674,
                  28.783828
                ],
                [
                  115.796404,
                  28.787064
                ],
                [
                  115.806274,
                  28.788133
                ],
                [
                  115.811018,
                  28.792969
                ],
                [
                  115.805846,
                  28.795194
                ],
                [
                  115.804731,
                  28.796975
                ],
                [
                  115.807987,
                  28.799951
                ],
                [
                  115.813182,
                  28.800587
                ],
                [
                  115.817441,
                  28.803669
                ],
                [
                  115.816663,
                  28.80676
                ],
                [
                  115.813362,
                  28.806866
                ],
                [
                  115.809497,
                  28.807993
                ],
                [
                  115.807198,
                  28.809553
                ],
                [
                  115.80908,
                  28.812221
                ],
                [
                  115.811379,
                  28.813492
                ],
                [
                  115.813373,
                  28.811816
                ],
                [
                  115.816945,
                  28.812095
                ],
                [
                  115.821261,
                  28.813954
                ],
                [
                  115.826297,
                  28.820935
                ],
                [
                  115.829914,
                  28.819414
                ],
                [
                  115.83183,
                  28.8208
                ],
                [
                  115.835233,
                  28.819838
                ],
                [
                  115.833813,
                  28.815774
                ],
                [
                  115.828483,
                  28.809929
                ],
                [
                  115.827751,
                  28.807434
                ],
                [
                  115.828799,
                  28.802523
                ],
                [
                  115.833261,
                  28.803842
                ],
                [
                  115.838624,
                  28.801155
                ],
                [
                  115.839244,
                  28.799162
                ],
                [
                  115.842613,
                  28.796619
                ],
                [
                  115.850129,
                  28.793835
                ],
                [
                  115.853678,
                  28.793691
                ],
                [
                  115.855864,
                  28.798805
                ],
                [
                  115.858569,
                  28.799961
                ],
                [
                  115.859188,
                  28.797178
                ],
                [
                  115.864721,
                  28.793508
                ],
                [
                  115.86862,
                  28.794279
                ],
                [
                  115.868912,
                  28.79606
                ],
                [
                  115.871155,
                  28.797601
                ],
                [
                  115.87102,
                  28.80078
                ],
                [
                  115.868067,
                  28.801579
                ],
                [
                  115.867391,
                  28.805104
                ],
                [
                  115.868845,
                  28.805595
                ],
                [
                  115.874073,
                  28.804372
                ],
                [
                  115.877206,
                  28.806587
                ],
                [
                  115.882411,
                  28.805431
                ],
                [
                  115.885995,
                  28.808137
                ],
                [
                  115.889645,
                  28.80936
                ],
                [
                  115.898784,
                  28.800096
                ],
                [
                  115.899268,
                  28.795251
                ],
                [
                  115.90231,
                  28.793941
                ],
                [
                  115.910581,
                  28.794221
                ],
                [
                  115.911133,
                  28.791476
                ],
                [
                  115.909443,
                  28.789723
                ],
                [
                  115.909544,
                  28.787421
                ],
                [
                  115.911235,
                  28.782277
                ],
                [
                  115.919133,
                  28.780639
                ],
                [
                  115.921229,
                  28.78194
                ],
                [
                  115.924317,
                  28.779098
                ],
                [
                  115.927201,
                  28.778588
                ],
                [
                  115.926379,
                  28.776121
                ],
                [
                  115.92612,
                  28.768781
                ],
                [
                  115.932892,
                  28.770486
                ],
                [
                  115.939235,
                  28.773569
                ],
                [
                  115.945162,
                  28.777046
                ],
                [
                  115.95065,
                  28.779137
                ],
                [
                  115.952779,
                  28.78062
                ],
                [
                  115.952013,
                  28.783876
                ],
                [
                  115.956363,
                  28.788731
                ],
                [
                  115.958267,
                  28.792294
                ],
                [
                  115.959641,
                  28.792612
                ],
                [
                  115.958672,
                  28.79423
                ],
                [
                  115.958706,
                  28.798642
                ],
                [
                  115.960588,
                  28.806693
                ],
                [
                  115.961918,
                  28.809043
                ],
                [
                  115.97296,
                  28.816467
                ],
                [
                  115.979293,
                  28.821041
                ],
                [
                  115.99891,
                  28.836986
                ],
                [
                  116.001524,
                  28.838064
                ],
                [
                  116.006933,
                  28.838439
                ],
                [
                  116.010561,
                  28.837737
                ],
                [
                  116.019046,
                  28.834983
                ],
                [
                  116.027057,
                  28.834184
                ],
                [
                  116.03028,
                  28.836138
                ],
                [
                  116.031767,
                  28.843128
                ],
                [
                  116.033097,
                  28.859521
                ],
                [
                  116.034381,
                  28.864161
                ],
                [
                  116.036567,
                  28.868251
                ],
                [
                  116.05072,
                  28.881061
                ],
                [
                  116.059903,
                  28.889029
                ],
                [
                  116.063993,
                  28.891743
                ],
                [
                  116.069402,
                  28.892157
                ],
                [
                  116.092603,
                  28.881908
                ],
                [
                  116.096005,
                  28.88083
                ],
                [
                  116.101414,
                  28.881292
                ],
                [
                  116.104513,
                  28.88237
                ],
                [
                  116.121538,
                  28.892031
                ],
                [
                  116.126384,
                  28.893706
                ],
                [
                  116.130508,
                  28.897073
                ],
                [
                  116.132254,
                  28.897227
                ],
                [
                  116.134429,
                  28.894639
                ],
                [
                  116.136468,
                  28.889809
                ],
                [
                  116.141652,
                  28.88466
                ],
                [
                  116.145787,
                  28.883438
                ],
                [
                  116.151579,
                  28.883515
                ],
                [
                  116.155229,
                  28.884987
                ],
                [
                  116.161652,
                  28.889664
                ],
                [
                  116.165754,
                  28.895274
                ],
                [
                  116.170881,
                  28.905656
                ],
                [
                  116.175264,
                  28.910736
                ],
                [
                  116.176638,
                  28.916191
                ],
                [
                  116.176774,
                  28.920558
                ],
                [
                  116.177878,
                  28.924041
                ],
                [
                  116.180458,
                  28.928927
                ],
                [
                  116.187219,
                  28.935814
                ],
                [
                  116.19443,
                  28.937517
                ],
                [
                  116.20216,
                  28.937699
                ],
                [
                  116.212572,
                  28.940845
                ],
                [
                  116.217586,
                  28.940575
                ],
                [
                  116.220876,
                  28.941489
                ],
                [
                  116.228854,
                  28.946144
                ],
                [
                  116.236989,
                  28.948106
                ],
                [
                  116.239164,
                  28.954694
                ],
                [
                  116.240708,
                  28.957021
                ],
                [
                  116.244471,
                  28.960444
                ],
                [
                  116.249722,
                  28.960377
                ],
                [
                  116.25859,
                  28.957415
                ],
                [
                  116.261238,
                  28.955684
                ],
                [
                  116.264708,
                  28.950895
                ],
                [
                  116.265621,
                  28.943855
                ],
                [
                  116.269587,
                  28.928302
                ],
                [
                  116.270613,
                  28.921674
                ],
                [
                  116.268167,
                  28.916778
                ],
                [
                  116.266534,
                  28.911785
                ],
                [
                  116.267965,
                  28.905771
                ],
                [
                  116.269283,
                  28.903828
                ],
                [
                  116.272753,
                  28.902202
                ],
                [
                  116.28223,
                  28.900576
                ],
                [
                  116.28499,
                  28.89895
                ],
                [
                  116.289982,
                  28.891512
                ],
                [
                  116.302478,
                  28.868511
                ],
                [
                  116.324236,
                  28.87239
                ],
                [
                  116.326738,
                  28.875383
                ],
                [
                  116.330885,
                  28.877866
                ],
                [
                  116.337431,
                  28.879031
                ],
                [
                  116.342062,
                  28.877654
                ],
                [
                  116.346152,
                  28.881167
                ],
                [
                  116.346355,
                  28.884093
                ],
                [
                  116.344395,
                  28.886681
                ],
                [
                  116.344451,
                  28.888327
                ],
                [
                  116.347876,
                  28.893629
                ],
                [
                  116.34862,
                  28.896198
                ],
                [
                  116.352102,
                  28.900181
                ],
                [
                  116.355234,
                  28.901971
                ],
                [
                  116.358615,
                  28.902231
                ],
                [
                  116.358705,
                  28.910274
                ],
                [
                  116.362344,
                  28.918326
                ],
                [
                  116.366953,
                  28.927167
                ],
                [
                  116.373455,
                  28.936584
                ],
                [
                  116.375753,
                  28.939325
                ],
                [
                  116.382232,
                  28.944538
                ],
                [
                  116.386345,
                  28.946327
                ],
                [
                  116.398075,
                  28.950443
                ],
                [
                  116.404261,
                  28.953924
                ],
                [
                  116.40683,
                  28.964108
                ],
                [
                  116.40736,
                  28.972781
                ],
                [
                  116.407055,
                  28.980098
                ],
                [
                  116.40834,
                  28.989683
                ],
                [
                  116.408047,
                  28.993643
                ],
                [
                  116.406808,
                  28.997162
                ],
                [
                  116.408137,
                  29.000276
                ],
                [
                  116.407247,
                  29.00614
                ],
                [
                  116.404216,
                  29.011368
                ],
                [
                  116.402379,
                  29.016289
                ],
                [
                  116.407247,
                  29.024775
                ],
                [
                  116.409771,
                  29.030907
                ],
                [
                  116.407224,
                  29.038988
                ],
                [
                  116.404576,
                  29.045483
                ],
                [
                  116.400509,
                  29.050249
                ],
                [
                  116.400497,
                  29.053016
                ],
                [
                  116.394909,
                  29.052103
                ],
                [
                  116.37315,
                  29.049653
                ],
                [
                  116.36035,
                  29.059434
                ],
                [
                  116.341544,
                  29.073468
                ],
                [
                  116.318118,
                  29.091439
                ],
                [
                  116.290996,
                  29.108878
                ],
                [
                  116.286128,
                  29.109003
                ],
                [
                  116.276134,
                  29.105498
                ],
                [
                  116.272168,
                  29.103059
                ],
                [
                  116.268213,
                  29.098632
                ],
                [
                  116.264303,
                  29.091641
                ],
                [
                  116.262015,
                  29.082536
                ],
                [
                  116.262263,
                  29.077531
                ],
                [
                  116.265317,
                  29.066446
                ],
                [
                  116.268844,
                  29.059549
                ],
                [
                  116.272111,
                  29.050172
                ],
                [
                  116.273903,
                  29.046223
                ],
                [
                  116.275773,
                  29.032992
                ],
                [
                  116.277666,
                  29.027649
                ],
                [
                  116.27823,
                  29.023574
                ],
                [
                  116.277801,
                  29.018865
                ],
                [
                  116.274725,
                  29.006976
                ],
                [
                  116.272539,
                  29.002977
                ],
                [
                  116.2705,
                  29.001151
                ],
                [
                  116.265418,
                  29.002074
                ],
                [
                  116.260708,
                  28.999594
                ],
                [
                  116.255615,
                  29.000949
                ],
                [
                  116.253283,
                  29.00092
                ],
                [
                  116.249902,
                  28.999411
                ],
                [
                  116.246139,
                  28.994509
                ],
                [
                  116.242882,
                  28.991711
                ],
                [
                  116.238984,
                  28.990288
                ],
                [
                  116.236899,
                  28.991971
                ],
                [
                  116.234499,
                  29.004361
                ],
                [
                  116.234792,
                  29.006688
                ],
                [
                  116.237834,
                  29.012233
                ],
                [
                  116.237834,
                  29.014233
                ],
                [
                  116.236077,
                  29.016741
                ],
                [
                  116.236031,
                  29.025727
                ],
                [
                  116.22971,
                  29.032867
                ],
                [
                  116.224696,
                  29.035413
                ],
                [
                  116.217248,
                  29.036807
                ],
                [
                  116.205135,
                  29.036864
                ],
                [
                  116.197529,
                  29.037672
                ],
                [
                  116.18767,
                  29.039747
                ],
                [
                  116.183151,
                  29.041332
                ],
                [
                  116.175241,
                  29.045483
                ],
                [
                  116.171827,
                  29.047991
                ],
                [
                  116.165607,
                  29.054342
                ],
                [
                  116.163624,
                  29.058473
                ],
                [
                  116.153246,
                  29.074064
                ],
                [
                  116.150959,
                  29.076629
                ],
                [
                  116.143285,
                  29.082949
                ],
                [
                  116.142305,
                  29.084514
                ],
                [
                  116.144063,
                  29.090527
                ],
                [
                  116.147917,
                  29.093024
                ],
                [
                  116.150035,
                  29.095761
                ],
                [
                  116.149753,
                  29.097806
                ],
                [
                  116.155196,
                  29.103347
                ],
                [
                  116.170745,
                  29.116051
                ],
                [
                  116.173528,
                  29.118077
                ],
                [
                  116.132502,
                  29.122388
                ],
                [
                  116.111972,
                  29.117751
                ],
                [
                  116.092772,
                  29.119488
                ],
                [
                  116.091217,
                  29.115187
                ],
                [
                  116.086169,
                  29.112777
                ],
                [
                  116.074563,
                  29.115244
                ],
                [
                  116.072681,
                  29.1151
                ],
                [
                  116.064703,
                  29.116493
                ],
                [
                  116.059452,
                  29.113939
                ],
                [
                  116.048985,
                  29.105921
                ],
                [
                  116.042629,
                  29.102713
                ],
                [
                  116.04379,
                  29.106007
                ],
                [
                  116.043238,
                  29.108552
                ],
                [
                  116.03899,
                  29.108158
                ],
                [
                  116.038381,
                  29.104624
                ],
                [
                  116.039441,
                  29.102003
                ],
                [
                  116.036094,
                  29.099343
                ],
                [
                  116.033288,
                  29.095953
                ],
                [
                  116.027891,
                  29.095453
                ],
                [
                  116.026516,
                  29.094455
                ],
                [
                  116.025705,
                  29.090968
                ],
                [
                  116.021468,
                  29.090392
                ],
                [
                  116.018629,
                  29.088558
                ],
                [
                  116.016274,
                  29.094157
                ],
                [
                  116.008398,
                  29.099276
                ],
                [
                  116.007958,
                  29.105133
                ],
                [
                  116.010403,
                  29.107803
                ],
                [
                  116.005795,
                  29.108197
                ],
                [
                  116.004623,
                  29.111596
                ],
                [
                  116.003316,
                  29.111308
                ],
                [
                  116.001705,
                  29.107073
                ],
                [
                  115.996871,
                  29.103683
                ],
                [
                  115.995778,
                  29.098757
                ],
                [
                  115.992138,
                  29.095924
                ],
                [
                  115.987834,
                  29.089278
                ],
                [
                  115.984498,
                  29.08899
                ],
                [
                  115.980386,
                  29.09385
                ],
                [
                  115.98069,
                  29.099746
                ],
                [
                  115.978335,
                  29.100341
                ],
                [
                  115.973276,
                  29.098671
                ],
                [
                  115.966594,
                  29.098632
                ],
                [
                  115.965906,
                  29.097931
                ],
                [
                  115.95803,
                  29.096606
                ],
                [
                  115.95243,
                  29.092976
                ],
                [
                  115.945681,
                  29.092937
                ],
                [
                  115.94132,
                  29.090238
                ],
                [
                  115.9375,
                  29.089681
                ],
                [
                  115.936137,
                  29.092572
                ],
                [
                  115.930029,
                  29.093782
                ],
                [
                  115.929342,
                  29.090258
                ],
                [
                  115.926176,
                  29.089307
                ],
                [
                  115.9215,
                  29.083659
                ],
                [
                  115.920632,
                  29.081383
                ],
                [
                  115.921894,
                  29.080154
                ],
                [
                  115.919742,
                  29.077868
                ],
                [
                  115.916091,
                  29.077051
                ],
                [
                  115.915111,
                  29.072114
                ],
                [
                  115.917162,
                  29.066715
                ],
                [
                  115.918874,
                  29.066014
                ],
                [
                  115.921398,
                  29.060452
                ],
                [
                  115.914976,
                  29.049144
                ],
                [
                  115.914176,
                  29.045243
                ],
                [
                  115.914446,
                  29.041832
                ],
                [
                  115.908654,
                  29.033098
                ],
                [
                  115.906029,
                  29.03058
                ],
                [
                  115.894524,
                  29.026467
                ],
                [
                  115.890074,
                  29.023267
                ],
                [
                  115.88693,
                  29.020057
                ],
                [
                  115.885082,
                  29.016395
                ],
                [
                  115.882716,
                  29.00837
                ],
                [
                  115.873453,
                  28.991394
                ],
                [
                  115.866963,
                  28.980944
                ],
                [
                  115.858321,
                  28.969618
                ],
                [
                  115.851785,
                  28.968993
                ],
                [
                  115.838861,
                  28.967098
                ],
                [
                  115.832382,
                  28.967685
                ],
                [
                  115.823571,
                  28.970358
                ],
                [
                  115.820325,
                  28.968829
                ],
                [
                  115.819683,
                  28.965723
                ],
                [
                  115.82588,
                  28.946182
                ],
                [
                  115.826162,
                  28.941941
                ],
                [
                  115.825035,
                  28.935997
                ],
                [
                  115.822782,
                  28.93289
                ],
                [
                  115.816562,
                  28.930091
                ],
                [
                  115.815311,
                  28.925907
                ],
                [
                  115.815537,
                  28.917903
                ],
                [
                  115.816618,
                  28.913218
                ],
                [
                  115.815976,
                  28.909533
                ],
                [
                  115.813159,
                  28.908196
                ],
                [
                  115.807581,
                  28.906762
                ],
                [
                  115.804314,
                  28.902452
                ],
                [
                  115.799221,
                  28.899392
                ],
                [
                  115.792764,
                  28.89996
                ],
                [
                  115.787682,
                  28.899825
                ],
                [
                  115.784392,
                  28.898594
                ],
                [
                  115.781508,
                  28.899999
                ],
                [
                  115.777496,
                  28.900374
                ],
                [
                  115.77193,
                  28.898757
                ],
                [
                  115.764189,
                  28.892464
                ],
                [
                  115.759941,
                  28.89309
                ],
                [
                  115.759896,
                  28.890222
                ],
                [
                  115.758487,
                  28.88849
                ],
                [
                  115.75958,
                  28.885911
                ],
                [
                  115.761653,
                  28.886104
                ],
                [
                  115.764301,
                  28.883342
                ],
                [
                  115.757158,
                  28.884622
                ],
                [
                  115.749349,
                  28.884795
                ],
                [
                  115.745608,
                  28.87854
                ],
                [
                  115.746701,
                  28.87392
                ],
                [
                  115.749022,
                  28.871216
                ],
                [
                  115.758307,
                  28.865114
                ],
                [
                  115.760425,
                  28.860465
                ],
                [
                  115.763254,
                  28.856124
                ],
                [
                  115.761924,
                  28.855046
                ],
                [
                  115.756774,
                  28.856913
                ],
                [
                  115.754983,
                  28.856239
                ],
                [
                  115.752696,
                  28.852937
                ],
                [
                  115.750442,
                  28.848192
                ],
                [
                  115.747219,
                  28.848298
                ],
                [
                  115.747648,
                  28.844659
                ],
                [
                  115.751242,
                  28.843224
                ],
                [
                  115.748932,
                  28.838979
                ],
                [
                  115.748346,
                  28.833019
                ],
                [
                  115.753879,
                  28.829331
                ],
                [
                  115.754115,
                  28.826741
                ],
                [
                  115.752098,
                  28.824845
                ],
                [
                  115.747343,
                  28.82342
                ],
                [
                  115.742769,
                  28.826077
                ],
                [
                  115.737766,
                  28.823901
                ],
                [
                  115.736064,
                  28.827127
                ],
                [
                  115.733394,
                  28.828917
                ],
                [
                  115.729179,
                  28.826963
                ],
                [
                  115.726678,
                  28.82367
                ],
                [
                  115.727196,
                  28.827396
                ],
                [
                  115.72936,
                  28.82964
                ],
                [
                  115.729078,
                  28.832085
                ],
                [
                  115.720683,
                  28.836293
                ],
                [
                  115.716435,
                  28.837448
                ],
                [
                  115.713911,
                  28.841482
                ],
                [
                  115.708649,
                  28.842117
                ],
                [
                  115.702835,
                  28.840163
                ],
                [
                  115.703049,
                  28.837303
                ],
                [
                  115.702001,
                  28.834637
                ],
                [
                  115.705923,
                  28.832942
                ],
                [
                  115.705393,
                  28.829591
                ],
                [
                  115.706351,
                  28.828003
                ],
                [
                  115.704863,
                  28.823111
                ],
                [
                  115.703173,
                  28.82082
                ],
                [
                  115.700424,
                  28.820926
                ],
                [
                  115.694824,
                  28.8234
                ],
                [
                  115.692333,
                  28.822746
                ],
                [
                  115.690542,
                  28.81926
                ],
                [
                  115.693122,
                  28.818441
                ],
                [
                  115.691849,
                  28.816631
                ],
                [
                  115.687916,
                  28.817103
                ],
                [
                  115.6867,
                  28.815552
                ],
                [
                  115.679477,
                  28.809659
                ],
                [
                  115.675533,
                  28.805162
                ],
                [
                  115.672085,
                  28.799489
                ],
                [
                  115.668524,
                  28.798709
                ],
                [
                  115.668829,
                  28.796667
                ],
                [
                  115.665786,
                  28.792603
                ],
                [
                  115.662665,
                  28.792564
                ],
                [
                  115.661482,
                  28.794731
                ],
                [
                  115.661944,
                  28.798584
                ],
                [
                  115.664152,
                  28.799373
                ],
                [
                  115.664164,
                  28.803187
                ],
                [
                  115.668141,
                  28.804362
                ],
                [
                  115.667736,
                  28.807868
                ],
                [
                  115.669831,
                  28.810978
                ],
                [
                  115.667015,
                  28.814638
                ],
                [
                  115.660524,
                  28.8138
                ],
                [
                  115.659364,
                  28.811537
                ],
                [
                  115.65933,
                  28.805807
                ],
                [
                  115.657482,
                  28.801117
                ],
                [
                  115.655352,
                  28.790358
                ],
                [
                  115.65222,
                  28.781969
                ],
                [
                  115.643453,
                  28.765881
                ],
                [
                  115.636738,
                  28.757826
                ],
                [
                  115.634,
                  28.752604
                ],
                [
                  115.634574,
                  28.748894
                ],
                [
                  115.643014,
                  28.741687
                ],
                [
                  115.648783,
                  28.733813
                ],
                [
                  115.650101,
                  28.727742
                ],
                [
                  115.648794,
                  28.721169
                ],
                [
                  115.645786,
                  28.718846
                ],
                [
                  115.648501,
                  28.711829
                ],
                [
                  115.647127,
                  28.707366
                ],
                [
                  115.644445,
                  28.70753
                ],
                [
                  115.641391,
                  28.70242
                ],
                [
                  115.636276,
                  28.69949
                ],
                [
                  115.635555,
                  28.69734
                ],
                [
                  115.637256,
                  28.692587
                ],
                [
                  115.637673,
                  28.68633
                ],
                [
                  115.630371,
                  28.681519
                ],
                [
                  115.626135,
                  28.677893
                ],
                [
                  115.624163,
                  28.666409
                ],
                [
                  115.624737,
                  28.663226
                ],
                [
                  115.624287,
                  28.659938
                ],
                [
                  115.621425,
                  28.658019
                ],
                [
                  115.617785,
                  28.657913
                ],
                [
                  115.610641,
                  28.655752
                ],
                [
                  115.605605,
                  28.653129
                ],
                [
                  115.597233,
                  28.645992
                ],
                [
                  115.594325,
                  28.641786
                ],
                [
                  115.592015,
                  28.635642
                ],
                [
                  115.588173,
                  28.631774
                ],
                [
                  115.583846,
                  28.628774
                ],
                [
                  115.581604,
                  28.62369
                ],
                [
                  115.580072,
                  28.622812
                ],
                [
                  115.578156,
                  28.614679
                ],
                [
                  115.575035,
                  28.611003
                ],
                [
                  115.572432,
                  28.60917
                ],
                [
                  115.564127,
                  28.608726
                ],
                [
                  115.564747,
                  28.605175
                ],
                [
                  115.563711,
                  28.601904
                ],
                [
                  115.558865,
                  28.600196
                ],
                [
                  115.559417,
                  28.596934
                ],
                [
                  115.561761,
                  28.590874
                ],
                [
                  115.560679,
                  28.588269
                ],
                [
                  115.561558,
                  28.586493
                ],
                [
                  115.562606,
                  28.584206
                ],
                [
                  115.566111,
                  28.584698
                ],
                [
                  115.569232,
                  28.586396
                ],
                [
                  115.571384,
                  28.589388
                ],
                [
                  115.573097,
                  28.590179
                ],
                [
                  115.58086,
                  28.586039
                ],
                [
                  115.582787,
                  28.583048
                ],
                [
                  115.582336,
                  28.579428
                ],
                [
                  115.583677,
                  28.576649
                ],
                [
                  115.586922,
                  28.575075
                ],
                [
                  115.587306,
                  28.573541
                ],
                [
                  115.5853,
                  28.570095
                ],
                [
                  115.582111,
                  28.56829
                ],
                [
                  115.566325,
                  28.565655
                ],
                [
                  115.563158,
                  28.563802
                ],
                [
                  115.563012,
                  28.559033
                ],
                [
                  115.566753,
                  28.552478
                ],
                [
                  115.569412,
                  28.542351
                ],
                [
                  115.569547,
                  28.538962
                ],
                [
                  115.568252,
                  28.533034
                ],
                [
                  115.568635,
                  28.530272
                ],
                [
                  115.57064,
                  28.525512
                ],
                [
                  115.573074,
                  28.517729
                ],
                [
                  115.572409,
                  28.514551
                ],
                [
                  115.570708,
                  28.515131
                ],
                [
                  115.567666,
                  28.513383
                ],
                [
                  115.562358,
                  28.514735
                ],
                [
                  115.559068,
                  28.510853
                ],
                [
                  115.558933,
                  28.507752
                ],
                [
                  115.56015,
                  28.503078
                ],
                [
                  115.567801,
                  28.497891
                ],
                [
                  115.567936,
                  28.495776
                ],
                [
                  115.566054,
                  28.494375
                ],
                [
                  115.553705,
                  28.488667
                ],
                [
                  115.55331,
                  28.486918
                ],
                [
                  115.550392,
                  28.484107
                ],
                [
                  115.545738,
                  28.481325
                ],
                [
                  115.545783,
                  28.475065
                ],
                [
                  115.546955,
                  28.473307
                ],
                [
                  115.549378,
                  28.465481
                ],
                [
                  115.54984,
                  28.461452
                ],
                [
                  115.54913,
                  28.457471
                ],
                [
                  115.551147,
                  28.453838
                ],
                [
                  115.548781,
                  28.449586
                ],
                [
                  115.54291,
                  28.444677
                ],
                [
                  115.54184,
                  28.442783
                ],
                [
                  115.549119,
                  28.438251
                ],
                [
                  115.553412,
                  28.4305
                ],
                [
                  115.554291,
                  28.423415
                ],
                [
                  115.553862,
                  28.41662
                ],
                [
                  115.551012,
                  28.409737
                ],
                [
                  115.547969,
                  28.40792
                ],
                [
                  115.544273,
                  28.408113
                ],
                [
                  115.538741,
                  28.407504
                ],
                [
                  115.535935,
                  28.404894
                ],
                [
                  115.532882,
                  28.398977
                ],
                [
                  115.531608,
                  28.392654
                ],
                [
                  115.534944,
                  28.39046
                ],
                [
                  115.540656,
                  28.393312
                ],
                [
                  115.545637,
                  28.390102
                ],
                [
                  115.552702,
                  28.387163
                ],
                [
                  115.557085,
                  28.387627
                ],
                [
                  115.55935,
                  28.389048
                ],
                [
                  115.563868,
                  28.395188
                ],
                [
                  115.56593,
                  28.399132
                ],
                [
                  115.567801,
                  28.399992
                ],
                [
                  115.571947,
                  28.397585
                ],
                [
                  115.576545,
                  28.396773
                ],
                [
                  115.583407,
                  28.397469
                ],
                [
                  115.588331,
                  28.399132
                ],
                [
                  115.58966,
                  28.401955
                ],
                [
                  115.587959,
                  28.403966
                ],
                [
                  115.589221,
                  28.40559
                ],
                [
                  115.58992,
                  28.409157
                ],
                [
                  115.59392,
                  28.413217
                ],
                [
                  115.597841,
                  28.416001
                ],
                [
                  115.598506,
                  28.417325
                ],
                [
                  115.61232,
                  28.416939
                ],
                [
                  115.614101,
                  28.417954
                ],
                [
                  115.618123,
                  28.418012
                ],
                [
                  115.619554,
                  28.416987
                ],
                [
                  115.619239,
                  28.414464
                ],
                [
                  115.616703,
                  28.409186
                ],
                [
                  115.617819,
                  28.40357
                ],
                [
                  115.622112,
                  28.398011
                ],
                [
                  115.627171,
                  28.396705
                ],
                [
                  115.63294,
                  28.396657
                ],
                [
                  115.638845,
                  28.397237
                ],
                [
                  115.64307,
                  28.396386
                ],
                [
                  115.648265,
                  28.39278
                ],
                [
                  115.650868,
                  28.386776
                ],
                [
                  115.653403,
                  28.384591
                ],
                [
                  115.654575,
                  28.381274
                ],
                [
                  115.65231,
                  28.375598
                ],
                [
                  115.64991,
                  28.37289
                ],
                [
                  115.647634,
                  28.372088
                ],
                [
                  115.638552,
                  28.366111
                ],
                [
                  115.633955,
                  28.357736
                ],
                [
                  115.632535,
                  28.35613
                ],
                [
                  115.631509,
                  28.350792
                ],
                [
                  115.630338,
                  28.348383
                ],
                [
                  115.621988,
                  28.345559
                ],
                [
                  115.624219,
                  28.342579
                ],
                [
                  115.625999,
                  28.342744
                ],
                [
                  115.629538,
                  28.340355
                ],
                [
                  115.629019,
                  28.338178
                ],
                [
                  115.630574,
                  28.336601
                ],
                [
                  115.635521,
                  28.337559
                ],
                [
                  115.644231,
                  28.335924
                ],
                [
                  115.648873,
                  28.334473
                ],
                [
                  115.651916,
                  28.335025
                ],
                [
                  115.65702,
                  28.338904
                ],
                [
                  115.658935,
                  28.34226
                ],
                [
                  115.658981,
                  28.34464
                ],
                [
                  115.663521,
                  28.34611
                ],
                [
                  115.669978,
                  28.346255
                ],
                [
                  115.671071,
                  28.345481
                ],
                [
                  115.671217,
                  28.341912
                ],
                [
                  115.669471,
                  28.339378
                ],
                [
                  115.672536,
                  28.337404
                ],
                [
                  115.675082,
                  28.340732
                ],
                [
                  115.678136,
                  28.338971
                ],
                [
                  115.682778,
                  28.339697
                ],
                [
                  115.679116,
                  28.342328
                ],
                [
                  115.680761,
                  28.345539
                ],
                [
                  115.68226,
                  28.345539
                ],
                [
                  115.685111,
                  28.348983
                ],
                [
                  115.690666,
                  28.349302
                ],
                [
                  115.694294,
                  28.354718
                ],
                [
                  115.692886,
                  28.35791
                ],
                [
                  115.689314,
                  28.358307
                ],
                [
                  115.691556,
                  28.360763
                ],
                [
                  115.690981,
                  28.362156
                ],
                [
                  115.682632,
                  28.362813
                ],
                [
                  115.681685,
                  28.365483
                ],
                [
                  115.678451,
                  28.365096
                ],
                [
                  115.675139,
                  28.361933
                ],
                [
                  115.672987,
                  28.356633
                ],
                [
                  115.669978,
                  28.355502
                ],
                [
                  115.670496,
                  28.357088
                ],
                [
                  115.668288,
                  28.363181
                ],
                [
                  115.669313,
                  28.367446
                ],
                [
                  115.673223,
                  28.367185
                ],
                [
                  115.675251,
                  28.370937
                ],
                [
                  115.674203,
                  28.375018
                ],
                [
                  115.681246,
                  28.374263
                ],
                [
                  115.683815,
                  28.368423
                ],
                [
                  115.687015,
                  28.367533
                ],
                [
                  115.68679,
                  28.365966
                ],
                [
                  115.68413,
                  28.365405
                ],
                [
                  115.686869,
                  28.363229
                ],
                [
                  115.68946,
                  28.364516
                ],
                [
                  115.692322,
                  28.36761
                ],
                [
                  115.696063,
                  28.367397
                ],
                [
                  115.701337,
                  28.364902
                ],
                [
                  115.70421,
                  28.365309
                ],
                [
                  115.706531,
                  28.367562
                ],
                [
                  115.711703,
                  28.365579
                ],
                [
                  115.715816,
                  28.362533
                ],
                [
                  115.720041,
                  28.361866
                ],
                [
                  115.721675,
                  28.360135
                ],
                [
                  115.727016,
                  28.350434
                ],
                [
                  115.728571,
                  28.350018
                ],
                [
                  115.732819,
                  28.352349
                ],
                [
                  115.745969,
                  28.362494
                ],
                [
                  115.750712,
                  28.365473
                ],
                [
                  115.757304,
                  28.36849
                ],
                [
                  115.764234,
                  28.364651
                ],
                [
                  115.768482,
                  28.361605
                ],
                [
                  115.772527,
                  28.360502
                ],
                [
                  115.777643,
                  28.362165
                ],
                [
                  115.779705,
                  28.365995
                ],
                [
                  115.784257,
                  28.36968
                ],
                [
                  115.785226,
                  28.371295
                ],
                [
                  115.790736,
                  28.376265
                ],
                [
                  115.801407,
                  28.380442
                ],
                [
                  115.80206,
                  28.385645
                ],
                [
                  115.800697,
                  28.392935
                ],
                [
                  115.800573,
                  28.3986
                ],
                [
                  115.80277,
                  28.399867
                ],
                [
                  115.807435,
                  28.400254
                ],
                [
                  115.814229,
                  28.402941
                ],
                [
                  115.820123,
                  28.401597
                ],
                [
                  115.824111,
                  28.399751
                ],
                [
                  115.821306,
                  28.405261
                ],
                [
                  115.83601,
                  28.44718
                ],
                [
                  115.83885,
                  28.453799
                ],
                [
                  115.83956,
                  28.463075
                ],
                [
                  115.839165,
                  28.473577
                ],
                [
                  115.835098,
                  28.483315
                ],
                [
                  115.819739,
                  28.497621
                ],
                [
                  115.813351,
                  28.510476
                ],
                [
                  115.80908,
                  28.520983
                ],
                [
                  115.808156,
                  28.525367
                ],
                [
                  115.809215,
                  28.532937
                ],
                [
                  115.805846,
                  28.527202
                ],
                [
                  115.803829,
                  28.520297
                ],
                [
                  115.80544,
                  28.513421
                ],
                [
                  115.806883,
                  28.50981
                ],
                [
                  115.798364,
                  28.491555
                ],
                [
                  115.787029,
                  28.489739
                ],
                [
                  115.769237,
                  28.489546
                ],
                [
                  115.764166,
                  28.508515
                ],
                [
                  115.761676,
                  28.509356
                ],
                [
                  115.748774,
                  28.511896
                ],
                [
                  115.734689,
                  28.512205
                ],
                [
                  115.723579,
                  28.51037
                ],
                [
                  115.723038,
                  28.513644
                ],
                [
                  115.721044,
                  28.513972
                ],
                [
                  115.720571,
                  28.511838
                ],
                [
                  115.718768,
                  28.512069
                ],
                [
                  115.718768,
                  28.51431
                ],
                [
                  115.714542,
                  28.517661
                ],
                [
                  115.711804,
                  28.516715
                ],
                [
                  115.711635,
                  28.520037
                ],
                [
                  115.707827,
                  28.523069
                ],
                [
                  115.709494,
                  28.524488
                ],
                [
                  115.711038,
                  28.528177
                ],
                [
                  115.714362,
                  28.530069
                ],
                [
                  115.71514,
                  28.53174
                ],
                [
                  115.715072,
                  28.536075
                ],
                [
                  115.718757,
                  28.53678
                ],
                [
                  115.723219,
                  28.538981
                ],
                [
                  115.724582,
                  28.542602
                ],
                [
                  115.724402,
                  28.54545
                ],
                [
                  115.722915,
                  28.548182
                ],
                [
                  115.723985,
                  28.549196
                ],
                [
                  115.729754,
                  28.549293
                ],
                [
                  115.727354,
                  28.557141
                ],
                [
                  115.722205,
                  28.561359
                ],
                [
                  115.71843,
                  28.575384
                ],
                [
                  115.714306,
                  28.583675
                ],
                [
                  115.712255,
                  28.592264
                ],
                [
                  115.711387,
                  28.597841
                ],
                [
                  115.718081,
                  28.603419
                ],
                [
                  115.717359,
                  28.60805
                ],
                [
                  115.742892,
                  28.621413
                ],
                [
                  115.747005,
                  28.622899
                ],
                [
                  115.755918,
                  28.622985
                ],
                [
                  115.76322,
                  28.62613
                ],
                [
                  115.767659,
                  28.626864
                ],
                [
                  115.770217,
                  28.631919
                ],
                [
                  115.756966,
                  28.637967
                ],
                [
                  115.759524,
                  28.63869
                ],
                [
                  115.767614,
                  28.643388
                ],
                [
                  115.77229,
                  28.649329
                ],
                [
                  115.772606,
                  28.651017
                ],
                [
                  115.769237,
                  28.654103
                ],
                [
                  115.764279,
                  28.656061
                ],
                [
                  115.765834,
                  28.660083
                ],
                [
                  115.76669,
                  28.665261
                ],
                [
                  115.761958,
                  28.669996
                ],
                [
                  115.76447,
                  28.671616
                ],
                [
                  115.771468,
                  28.673024
                ],
                [
                  115.771907,
                  28.670825
                ],
                [
                  115.77682,
                  28.670739
                ],
                [
                  115.776392,
                  28.672744
                ],
                [
                  115.77806,
                  28.673024
                ],
                [
                  115.779806,
                  28.669774
                ],
                [
                  115.78055,
                  28.665917
                ],
                [
                  115.785688,
                  28.664384
                ],
                [
                  115.794308,
                  28.664519
                ],
                [
                  115.801091,
                  28.666775
                ],
                [
                  115.810353,
                  28.66934
                ],
                [
                  115.821339,
                  28.671751
                ],
                [
                  115.833058,
                  28.675319
                ],
                [
                  115.833926,
                  28.67905
                ],
                [
                  115.841036,
                  28.689811
                ],
                [
                  115.843548,
                  28.694284
                ]
              ]
            ]
          ]
        },
        "id": 4
      },
      {
        "type": "Feature",
        "properties": {
          "adcode": 360113,
          "name": "红谷滩区",
          "center": [
            115.8580521,
            28.69819928
          ],
          "centroid": [
            115.791047,
            28.600613
          ],
          "childrenNum": 0,
          "level": "district",
          "parent": {
            "adcode": 360100
          },
          "subFeatureIndex": 5,
          "acroutes": [
            100000,
            360000,
            360100
          ]
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  115.809215,
                  28.532937
                ],
                [
                  115.810815,
                  28.536017
                ],
                [
                  115.814263,
                  28.539899
                ],
                [
                  115.817463,
                  28.556813
                ],
                [
                  115.818861,
                  28.562412
                ],
                [
                  115.818489,
                  28.565607
                ],
                [
                  115.818838,
                  28.576977
                ],
                [
                  115.820877,
                  28.588954
                ],
                [
                  115.822196,
                  28.5987
                ],
                [
                  115.826647,
                  28.607356
                ],
                [
                  115.832923,
                  28.617149
                ],
                [
                  115.833069,
                  28.621529
                ],
                [
                  115.835334,
                  28.626622
                ],
                [
                  115.842016,
                  28.635401
                ],
                [
                  115.844089,
                  28.640195
                ],
                [
                  115.847898,
                  28.643706
                ],
                [
                  115.854456,
                  28.646436
                ],
                [
                  115.85734,
                  28.64877
                ],
                [
                  115.866332,
                  28.657266
                ],
                [
                  115.86898,
                  28.662908
                ],
                [
                  115.868642,
                  28.667836
                ],
                [
                  115.873994,
                  28.687776
                ],
                [
                  115.877104,
                  28.693995
                ],
                [
                  115.882704,
                  28.701081
                ],
                [
                  115.888879,
                  28.712137
                ],
                [
                  115.889578,
                  28.715434
                ],
                [
                  115.891674,
                  28.719627
                ],
                [
                  115.89306,
                  28.725631
                ],
                [
                  115.892316,
                  28.735538
                ],
                [
                  115.889814,
                  28.744606
                ],
                [
                  115.88649,
                  28.739682
                ],
                [
                  115.883178,
                  28.73628
                ],
                [
                  115.880789,
                  28.735375
                ],
                [
                  115.878434,
                  28.730248
                ],
                [
                  115.876507,
                  28.73098
                ],
                [
                  115.874231,
                  28.728397
                ],
                [
                  115.871955,
                  28.730084
                ],
                [
                  115.873352,
                  28.731616
                ],
                [
                  115.870298,
                  28.733592
                ],
                [
                  115.867831,
                  28.732801
                ],
                [
                  115.866084,
                  28.743373
                ],
                [
                  115.86551,
                  28.738391
                ],
                [
                  115.866896,
                  28.735847
                ],
                [
                  115.864631,
                  28.734372
                ],
                [
                  115.864033,
                  28.731259
                ],
                [
                  115.865994,
                  28.733071
                ],
                [
                  115.865814,
                  28.728657
                ],
                [
                  115.863436,
                  28.725853
                ],
                [
                  115.860732,
                  28.727048
                ],
                [
                  115.862884,
                  28.729101
                ],
                [
                  115.855346,
                  28.729004
                ],
                [
                  115.855785,
                  28.722383
                ],
                [
                  115.853306,
                  28.721766
                ],
                [
                  115.852157,
                  28.72006
                ],
                [
                  115.849442,
                  28.72193
                ],
                [
                  115.848878,
                  28.718229
                ],
                [
                  115.85218,
                  28.713737
                ],
                [
                  115.861138,
                  28.705688
                ],
                [
                  115.855763,
                  28.706681
                ],
                [
                  115.852698,
                  28.705766
                ],
                [
                  115.84952,
                  28.703732
                ],
                [
                  115.846298,
                  28.703095
                ],
                [
                  115.844934,
                  28.697244
                ],
                [
                  115.843548,
                  28.694284
                ],
                [
                  115.841036,
                  28.689811
                ],
                [
                  115.833926,
                  28.67905
                ],
                [
                  115.833058,
                  28.675319
                ],
                [
                  115.821339,
                  28.671751
                ],
                [
                  115.810353,
                  28.66934
                ],
                [
                  115.801091,
                  28.666775
                ],
                [
                  115.794308,
                  28.664519
                ],
                [
                  115.785688,
                  28.664384
                ],
                [
                  115.78055,
                  28.665917
                ],
                [
                  115.779806,
                  28.669774
                ],
                [
                  115.77806,
                  28.673024
                ],
                [
                  115.776392,
                  28.672744
                ],
                [
                  115.77682,
                  28.670739
                ],
                [
                  115.771907,
                  28.670825
                ],
                [
                  115.771468,
                  28.673024
                ],
                [
                  115.76447,
                  28.671616
                ],
                [
                  115.761958,
                  28.669996
                ],
                [
                  115.76669,
                  28.665261
                ],
                [
                  115.765834,
                  28.660083
                ],
                [
                  115.764279,
                  28.656061
                ],
                [
                  115.769237,
                  28.654103
                ],
                [
                  115.772606,
                  28.651017
                ],
                [
                  115.77229,
                  28.649329
                ],
                [
                  115.767614,
                  28.643388
                ],
                [
                  115.759524,
                  28.63869
                ],
                [
                  115.756966,
                  28.637967
                ],
                [
                  115.770217,
                  28.631919
                ],
                [
                  115.767659,
                  28.626864
                ],
                [
                  115.76322,
                  28.62613
                ],
                [
                  115.755918,
                  28.622985
                ],
                [
                  115.747005,
                  28.622899
                ],
                [
                  115.742892,
                  28.621413
                ],
                [
                  115.717359,
                  28.60805
                ],
                [
                  115.718081,
                  28.603419
                ],
                [
                  115.711387,
                  28.597841
                ],
                [
                  115.712255,
                  28.592264
                ],
                [
                  115.714306,
                  28.583675
                ],
                [
                  115.71843,
                  28.575384
                ],
                [
                  115.722205,
                  28.561359
                ],
                [
                  115.727354,
                  28.557141
                ],
                [
                  115.729754,
                  28.549293
                ],
                [
                  115.723985,
                  28.549196
                ],
                [
                  115.722915,
                  28.548182
                ],
                [
                  115.724402,
                  28.54545
                ],
                [
                  115.724582,
                  28.542602
                ],
                [
                  115.723219,
                  28.538981
                ],
                [
                  115.718757,
                  28.53678
                ],
                [
                  115.715072,
                  28.536075
                ],
                [
                  115.71514,
                  28.53174
                ],
                [
                  115.714362,
                  28.530069
                ],
                [
                  115.711038,
                  28.528177
                ],
                [
                  115.709494,
                  28.524488
                ],
                [
                  115.707827,
                  28.523069
                ],
                [
                  115.711635,
                  28.520037
                ],
                [
                  115.711804,
                  28.516715
                ],
                [
                  115.714542,
                  28.517661
                ],
                [
                  115.718768,
                  28.51431
                ],
                [
                  115.718768,
                  28.512069
                ],
                [
                  115.720571,
                  28.511838
                ],
                [
                  115.721044,
                  28.513972
                ],
                [
                  115.723038,
                  28.513644
                ],
                [
                  115.723579,
                  28.51037
                ],
                [
                  115.734689,
                  28.512205
                ],
                [
                  115.748774,
                  28.511896
                ],
                [
                  115.761676,
                  28.509356
                ],
                [
                  115.764166,
                  28.508515
                ],
                [
                  115.769237,
                  28.489546
                ],
                [
                  115.787029,
                  28.489739
                ],
                [
                  115.798364,
                  28.491555
                ],
                [
                  115.806883,
                  28.50981
                ],
                [
                  115.80544,
                  28.513421
                ],
                [
                  115.803829,
                  28.520297
                ],
                [
                  115.805846,
                  28.527202
                ],
                [
                  115.809215,
                  28.532937
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "adcode": 360121,
          "name": "南昌县",
          "center": [
            115.942465,
            28.543781
          ],
          "centroid": [
            116.063936,
            28.615359
          ],
          "childrenNum": 0,
          "level": "district",
          "parent": {
            "adcode": 360100
          },
          "subFeatureIndex": 6,
          "acroutes": [
            100000,
            360000,
            360100
          ]
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  115.809215,
                  28.532937
                ],
                [
                  115.808156,
                  28.525367
                ],
                [
                  115.80908,
                  28.520983
                ],
                [
                  115.813351,
                  28.510476
                ],
                [
                  115.819739,
                  28.497621
                ],
                [
                  115.835098,
                  28.483315
                ],
                [
                  115.839165,
                  28.473577
                ],
                [
                  115.83956,
                  28.463075
                ],
                [
                  115.83885,
                  28.453799
                ],
                [
                  115.83601,
                  28.44718
                ],
                [
                  115.821306,
                  28.405261
                ],
                [
                  115.824111,
                  28.399751
                ],
                [
                  115.829678,
                  28.395632
                ],
                [
                  115.836067,
                  28.392345
                ],
                [
                  115.842027,
                  28.385915
                ],
                [
                  115.847909,
                  28.381574
                ],
                [
                  115.851515,
                  28.375724
                ],
                [
                  115.855368,
                  28.366092
                ],
                [
                  115.855188,
                  28.36175
                ],
                [
                  115.857532,
                  28.355444
                ],
                [
                  115.861532,
                  28.348267
                ],
                [
                  115.863188,
                  28.34315
                ],
                [
                  115.863504,
                  28.336156
                ],
                [
                  115.862783,
                  28.331029
                ],
                [
                  115.85858,
                  28.319962
                ],
                [
                  115.858625,
                  28.316701
                ],
                [
                  115.859898,
                  28.312724
                ],
                [
                  115.866186,
                  28.308835
                ],
                [
                  115.872056,
                  28.303232
                ],
                [
                  115.877645,
                  28.293681
                ],
                [
                  115.879358,
                  28.286887
                ],
                [
                  115.881735,
                  28.286955
                ],
                [
                  115.886941,
                  28.291562
                ],
                [
                  115.895268,
                  28.303668
                ],
                [
                  115.902457,
                  28.30987
                ],
                [
                  115.903449,
                  28.314389
                ],
                [
                  115.906513,
                  28.31644
                ],
                [
                  115.908057,
                  28.315995
                ],
                [
                  115.90959,
                  28.312831
                ],
                [
                  115.91013,
                  28.30719
                ],
                [
                  115.911922,
                  28.303813
                ],
                [
                  115.916519,
                  28.30271
                ],
                [
                  115.920181,
                  28.305951
                ],
                [
                  115.917263,
                  28.308351
                ],
                [
                  115.922097,
                  28.314921
                ],
                [
                  115.92337,
                  28.315608
                ],
                [
                  115.929759,
                  28.315182
                ],
                [
                  115.931032,
                  28.313827
                ],
                [
                  115.931303,
                  28.310228
                ],
                [
                  115.935156,
                  28.306396
                ],
                [
                  115.937782,
                  28.307625
                ],
                [
                  115.940261,
                  28.307325
                ],
                [
                  115.942627,
                  28.30538
                ],
                [
                  115.94923,
                  28.304045
                ],
                [
                  115.951788,
                  28.300997
                ],
                [
                  115.954109,
                  28.299932
                ],
                [
                  115.95767,
                  28.300648
                ],
                [
                  115.957929,
                  28.297262
                ],
                [
                  115.960002,
                  28.292752
                ],
                [
                  115.957456,
                  28.288232
                ],
                [
                  115.954898,
                  28.288213
                ],
                [
                  115.949703,
                  28.281312
                ],
                [
                  115.950841,
                  28.279386
                ],
                [
                  115.953309,
                  28.278506
                ],
                [
                  115.957523,
                  28.278544
                ],
                [
                  115.962222,
                  28.276705
                ],
                [
                  115.966121,
                  28.275979
                ],
                [
                  115.968622,
                  28.276463
                ],
                [
                  115.973862,
                  28.278844
                ],
                [
                  115.978707,
                  28.284293
                ],
                [
                  115.979957,
                  28.291068
                ],
                [
                  115.984758,
                  28.291949
                ],
                [
                  115.994572,
                  28.287778
                ],
                [
                  115.996611,
                  28.281738
                ],
                [
                  116.000488,
                  28.279677
                ],
                [
                  116.006617,
                  28.279038
                ],
                [
                  116.007891,
                  28.283335
                ],
                [
                  116.016589,
                  28.283171
                ],
                [
                  116.021119,
                  28.283935
                ],
                [
                  116.030336,
                  28.288465
                ],
                [
                  116.038393,
                  28.294939
                ],
                [
                  116.04432,
                  28.295984
                ],
                [
                  116.063103,
                  28.291929
                ],
                [
                  116.068771,
                  28.291978
                ],
                [
                  116.073492,
                  28.289016
                ],
                [
                  116.081909,
                  28.277547
                ],
                [
                  116.083622,
                  28.275834
                ],
                [
                  116.092952,
                  28.271837
                ],
                [
                  116.096208,
                  28.268294
                ],
                [
                  116.096546,
                  28.272689
                ],
                [
                  116.092073,
                  28.283819
                ],
                [
                  116.091048,
                  28.2883
                ],
                [
                  116.090743,
                  28.294291
                ],
                [
                  116.091814,
                  28.296478
                ],
                [
                  116.094766,
                  28.299129
                ],
                [
                  116.098586,
                  28.301374
                ],
                [
                  116.100175,
                  28.30479
                ],
                [
                  116.09951,
                  28.307693
                ],
                [
                  116.097065,
                  28.310344
                ],
                [
                  116.094203,
                  28.310644
                ],
                [
                  116.080456,
                  28.310073
                ],
                [
                  116.07836,
                  28.31048
                ],
                [
                  116.074889,
                  28.31346
                ],
                [
                  116.073875,
                  28.315695
                ],
                [
                  116.074044,
                  28.321674
                ],
                [
                  116.072839,
                  28.325263
                ],
                [
                  116.074157,
                  28.328553
                ],
                [
                  116.072084,
                  28.329394
                ],
                [
                  116.066484,
                  28.327682
                ],
                [
                  116.062585,
                  28.32775
                ],
                [
                  116.058957,
                  28.329539
                ],
                [
                  116.05863,
                  28.33132
                ],
                [
                  116.060264,
                  28.340935
                ],
                [
                  116.059993,
                  28.34523
                ],
                [
                  116.058821,
                  28.347377
                ],
                [
                  116.055047,
                  28.347561
                ],
                [
                  116.043734,
                  28.35143
                ],
                [
                  116.040229,
                  28.357339
                ],
                [
                  116.034111,
                  28.362649
                ],
                [
                  116.030843,
                  28.366769
                ],
                [
                  116.027012,
                  28.375318
                ],
                [
                  116.025987,
                  28.381322
                ],
                [
                  116.026809,
                  28.386022
                ],
                [
                  116.02895,
                  28.391533
                ],
                [
                  116.033345,
                  28.398678
                ],
                [
                  116.035903,
                  28.401839
                ],
                [
                  116.036815,
                  28.406025
                ],
                [
                  116.036004,
                  28.415808
                ],
                [
                  116.036004,
                  28.423705
                ],
                [
                  116.033345,
                  28.431041
                ],
                [
                  116.029052,
                  28.437854
                ],
                [
                  116.027936,
                  28.441923
                ],
                [
                  116.029356,
                  28.44774
                ],
                [
                  116.035857,
                  28.450717
                ],
                [
                  116.039655,
                  28.454959
                ],
                [
                  116.043204,
                  28.466196
                ],
                [
                  116.04503,
                  28.468486
                ],
                [
                  116.046979,
                  28.468891
                ],
                [
                  116.053931,
                  28.468602
                ],
                [
                  116.05712,
                  28.467964
                ],
                [
                  116.061345,
                  28.466022
                ],
                [
                  116.063024,
                  28.46636
                ],
                [
                  116.069086,
                  28.471626
                ],
                [
                  116.072805,
                  28.473056
                ],
                [
                  116.077999,
                  28.473104
                ],
                [
                  116.080321,
                  28.470872
                ],
                [
                  116.079475,
                  28.468003
                ],
                [
                  116.082845,
                  28.465703
                ],
                [
                  116.089977,
                  28.464428
                ],
                [
                  116.093403,
                  28.461626
                ],
                [
                  116.099273,
                  28.461693
                ],
                [
                  116.109347,
                  28.455915
                ],
                [
                  116.112209,
                  28.452089
                ],
                [
                  116.11684,
                  28.450504
                ],
                [
                  116.121246,
                  28.450717
                ],
                [
                  116.125155,
                  28.452079
                ],
                [
                  116.129054,
                  28.4555
                ],
                [
                  116.134023,
                  28.461664
                ],
                [
                  116.139263,
                  28.469664
                ],
                [
                  116.141877,
                  28.475384
                ],
                [
                  116.144784,
                  28.485691
                ],
                [
                  116.144559,
                  28.490734
                ],
                [
                  116.145111,
                  28.496703
                ],
                [
                  116.145731,
                  28.514126
                ],
                [
                  116.147308,
                  28.51939
                ],
                [
                  116.151241,
                  28.52809
                ],
                [
                  116.161945,
                  28.537427
                ],
                [
                  116.168458,
                  28.541067
                ],
                [
                  116.180413,
                  28.546502
                ],
                [
                  116.194228,
                  28.554679
                ],
                [
                  116.201,
                  28.559912
                ],
                [
                  116.211986,
                  28.569362
                ],
                [
                  116.214408,
                  28.573859
                ],
                [
                  116.220989,
                  28.582073
                ],
                [
                  116.228505,
                  28.588867
                ],
                [
                  116.231017,
                  28.599067
                ],
                [
                  116.232448,
                  28.600891
                ],
                [
                  116.23771,
                  28.602753
                ],
                [
                  116.240325,
                  28.606188
                ],
                [
                  116.244539,
                  28.614534
                ],
                [
                  116.255502,
                  28.617274
                ],
                [
                  116.260426,
                  28.616705
                ],
                [
                  116.264889,
                  28.614949
                ],
                [
                  116.27139,
                  28.614573
                ],
                [
                  116.277351,
                  28.616319
                ],
                [
                  116.281418,
                  28.618962
                ],
                [
                  116.28463,
                  28.619705
                ],
                [
                  116.289543,
                  28.623101
                ],
                [
                  116.291188,
                  28.6275
                ],
                [
                  116.290692,
                  28.631118
                ],
                [
                  116.292393,
                  28.633414
                ],
                [
                  116.295098,
                  28.642057
                ],
                [
                  116.294264,
                  28.645278
                ],
                [
                  116.288067,
                  28.64141
                ],
                [
                  116.284269,
                  28.641507
                ],
                [
                  116.282095,
                  28.643629
                ],
                [
                  116.279852,
                  28.649589
                ],
                [
                  116.275086,
                  28.650477
                ],
                [
                  116.271244,
                  28.653071
                ],
                [
                  116.271199,
                  28.65717
                ],
                [
                  116.268855,
                  28.661674
                ],
                [
                  116.268663,
                  28.663525
                ],
                [
                  116.265689,
                  28.666139
                ],
                [
                  116.266939,
                  28.671491
                ],
                [
                  116.27228,
                  28.67366
                ],
                [
                  116.278973,
                  28.677575
                ],
                [
                  116.282737,
                  28.683553
                ],
                [
                  116.285272,
                  28.685144
                ],
                [
                  116.291807,
                  28.691141
                ],
                [
                  116.291864,
                  28.695643
                ],
                [
                  116.292912,
                  28.697706
                ],
                [
                  116.298084,
                  28.703365
                ],
                [
                  116.298557,
                  28.706064
                ],
                [
                  116.295977,
                  28.7094
                ],
                [
                  116.293126,
                  28.714508
                ],
                [
                  116.291526,
                  28.719684
                ],
                [
                  116.292258,
                  28.723116
                ],
                [
                  116.297892,
                  28.727366
                ],
                [
                  116.306016,
                  28.732676
                ],
                [
                  116.317566,
                  28.737427
                ],
                [
                  116.322287,
                  28.743787
                ],
                [
                  116.324067,
                  28.75032
                ],
                [
                  116.323966,
                  28.753587
                ],
                [
                  116.320529,
                  28.765438
                ],
                [
                  116.316957,
                  28.771257
                ],
                [
                  116.307763,
                  28.777335
                ],
                [
                  116.304664,
                  28.782595
                ],
                [
                  116.301757,
                  28.785783
                ],
                [
                  116.296146,
                  28.788114
                ],
                [
                  116.287086,
                  28.787883
                ],
                [
                  116.282342,
                  28.791437
                ],
                [
                  116.280303,
                  28.794365
                ],
                [
                  116.279886,
                  28.796821
                ],
                [
                  116.274252,
                  28.800096
                ],
                [
                  116.270139,
                  28.79919
                ],
                [
                  116.253947,
                  28.798574
                ],
                [
                  116.249012,
                  28.799739
                ],
                [
                  116.246409,
                  28.80182
                ],
                [
                  116.244606,
                  28.805268
                ],
                [
                  116.242308,
                  28.811701
                ],
                [
                  116.241553,
                  28.816525
                ],
                [
                  116.24002,
                  28.820666
                ],
                [
                  116.240043,
                  28.824565
                ],
                [
                  116.245823,
                  28.831883
                ],
                [
                  116.246353,
                  28.833712
                ],
                [
                  116.245891,
                  28.841289
                ],
                [
                  116.244336,
                  28.844505
                ],
                [
                  116.238127,
                  28.851426
                ],
                [
                  116.237891,
                  28.855094
                ],
                [
                  116.240009,
                  28.860821
                ],
                [
                  116.243153,
                  28.864248
                ],
                [
                  116.25024,
                  28.869031
                ],
                [
                  116.259908,
                  28.871283
                ],
                [
                  116.27086,
                  28.869406
                ],
                [
                  116.27894,
                  28.866394
                ],
                [
                  116.283897,
                  28.866365
                ],
                [
                  116.293577,
                  28.867934
                ],
                [
                  116.302478,
                  28.868511
                ],
                [
                  116.289982,
                  28.891512
                ],
                [
                  116.28499,
                  28.89895
                ],
                [
                  116.28223,
                  28.900576
                ],
                [
                  116.272753,
                  28.902202
                ],
                [
                  116.269283,
                  28.903828
                ],
                [
                  116.267965,
                  28.905771
                ],
                [
                  116.266534,
                  28.911785
                ],
                [
                  116.268167,
                  28.916778
                ],
                [
                  116.270613,
                  28.921674
                ],
                [
                  116.269587,
                  28.928302
                ],
                [
                  116.265621,
                  28.943855
                ],
                [
                  116.264708,
                  28.950895
                ],
                [
                  116.261238,
                  28.955684
                ],
                [
                  116.25859,
                  28.957415
                ],
                [
                  116.249722,
                  28.960377
                ],
                [
                  116.244471,
                  28.960444
                ],
                [
                  116.240708,
                  28.957021
                ],
                [
                  116.239164,
                  28.954694
                ],
                [
                  116.236989,
                  28.948106
                ],
                [
                  116.228854,
                  28.946144
                ],
                [
                  116.220876,
                  28.941489
                ],
                [
                  116.217586,
                  28.940575
                ],
                [
                  116.212572,
                  28.940845
                ],
                [
                  116.20216,
                  28.937699
                ],
                [
                  116.19443,
                  28.937517
                ],
                [
                  116.187219,
                  28.935814
                ],
                [
                  116.180458,
                  28.928927
                ],
                [
                  116.177878,
                  28.924041
                ],
                [
                  116.176774,
                  28.920558
                ],
                [
                  116.176638,
                  28.916191
                ],
                [
                  116.175264,
                  28.910736
                ],
                [
                  116.170881,
                  28.905656
                ],
                [
                  116.165754,
                  28.895274
                ],
                [
                  116.161652,
                  28.889664
                ],
                [
                  116.155229,
                  28.884987
                ],
                [
                  116.151579,
                  28.883515
                ],
                [
                  116.145787,
                  28.883438
                ],
                [
                  116.141652,
                  28.88466
                ],
                [
                  116.136468,
                  28.889809
                ],
                [
                  116.134429,
                  28.894639
                ],
                [
                  116.132254,
                  28.897227
                ],
                [
                  116.130508,
                  28.897073
                ],
                [
                  116.126384,
                  28.893706
                ],
                [
                  116.121538,
                  28.892031
                ],
                [
                  116.104513,
                  28.88237
                ],
                [
                  116.101414,
                  28.881292
                ],
                [
                  116.096005,
                  28.88083
                ],
                [
                  116.092603,
                  28.881908
                ],
                [
                  116.069402,
                  28.892157
                ],
                [
                  116.063993,
                  28.891743
                ],
                [
                  116.059903,
                  28.889029
                ],
                [
                  116.05072,
                  28.881061
                ],
                [
                  116.036567,
                  28.868251
                ],
                [
                  116.034381,
                  28.864161
                ],
                [
                  116.033097,
                  28.859521
                ],
                [
                  116.031767,
                  28.843128
                ],
                [
                  116.03028,
                  28.836138
                ],
                [
                  116.027057,
                  28.834184
                ],
                [
                  116.019046,
                  28.834983
                ],
                [
                  116.010561,
                  28.837737
                ],
                [
                  116.006933,
                  28.838439
                ],
                [
                  116.001524,
                  28.838064
                ],
                [
                  115.99891,
                  28.836986
                ],
                [
                  115.979293,
                  28.821041
                ],
                [
                  115.97296,
                  28.816467
                ],
                [
                  115.961918,
                  28.809043
                ],
                [
                  115.960588,
                  28.806693
                ],
                [
                  115.958706,
                  28.798642
                ],
                [
                  115.958672,
                  28.79423
                ],
                [
                  115.959641,
                  28.792612
                ],
                [
                  115.961129,
                  28.793296
                ],
                [
                  115.968183,
                  28.791225
                ],
                [
                  115.968543,
                  28.786872
                ],
                [
                  115.975101,
                  28.787498
                ],
                [
                  115.982673,
                  28.787401
                ],
                [
                  115.985073,
                  28.781535
                ],
                [
                  115.985558,
                  28.778819
                ],
                [
                  115.982189,
                  28.778202
                ],
                [
                  115.979687,
                  28.77669
                ],
                [
                  115.972566,
                  28.768039
                ],
                [
                  115.966864,
                  28.762345
                ],
                [
                  115.962639,
                  28.759917
                ],
                [
                  115.955923,
                  28.757614
                ],
                [
                  115.952464,
                  28.755832
                ],
                [
                  115.944565,
                  28.747931
                ],
                [
                  115.939123,
                  28.740309
                ],
                [
                  115.937286,
                  28.735471
                ],
                [
                  115.932903,
                  28.732146
                ],
                [
                  115.937748,
                  28.726103
                ],
                [
                  115.942999,
                  28.727385
                ],
                [
                  115.947393,
                  28.729901
                ],
                [
                  115.953816,
                  28.732667
                ],
                [
                  115.959574,
                  28.734247
                ],
                [
                  115.968115,
                  28.734449
                ],
                [
                  115.97474,
                  28.733293
                ],
                [
                  115.981073,
                  28.73072
                ],
                [
                  115.997761,
                  28.7254
                ],
                [
                  116.002617,
                  28.725564
                ],
                [
                  116.010933,
                  28.724908
                ],
                [
                  116.016522,
                  28.723617
                ],
                [
                  116.022494,
                  28.72432
                ],
                [
                  116.022347,
                  28.721063
                ],
                [
                  116.023542,
                  28.720002
                ],
                [
                  116.028207,
                  28.721053
                ],
                [
                  116.027395,
                  28.718961
                ],
                [
                  116.022099,
                  28.717198
                ],
                [
                  116.017175,
                  28.713689
                ],
                [
                  116.015046,
                  28.711347
                ],
                [
                  116.013806,
                  28.707433
                ],
                [
                  116.011586,
                  28.704561
                ],
                [
                  116.01126,
                  28.701534
                ],
                [
                  116.015226,
                  28.700454
                ],
                [
                  116.01517,
                  28.699181
                ],
                [
                  116.010313,
                  28.694486
                ],
                [
                  116.006775,
                  28.69251
                ],
                [
                  116.006572,
                  28.690177
                ],
                [
                  116.003868,
                  28.682107
                ],
                [
                  115.998876,
                  28.676042
                ],
                [
                  115.996792,
                  28.670748
                ],
                [
                  115.995496,
                  28.66447
                ],
                [
                  116.000375,
                  28.662764
                ],
                [
                  116.005389,
                  28.661809
                ],
                [
                  116.005198,
                  28.660555
                ],
                [
                  116.00895,
                  28.654016
                ],
                [
                  116.012353,
                  28.650178
                ],
                [
                  116.015981,
                  28.647564
                ],
                [
                  116.019812,
                  28.642384
                ],
                [
                  116.026449,
                  28.639973
                ],
                [
                  116.030933,
                  28.641015
                ],
                [
                  116.035238,
                  28.643513
                ],
                [
                  116.037773,
                  28.648885
                ],
                [
                  116.045063,
                  28.655579
                ],
                [
                  116.04441,
                  28.647718
                ],
                [
                  116.044737,
                  28.637996
                ],
                [
                  116.046224,
                  28.635391
                ],
                [
                  116.052838,
                  28.631619
                ],
                [
                  116.055757,
                  28.627394
                ],
                [
                  116.054404,
                  28.625224
                ],
                [
                  116.055227,
                  28.621963
                ],
                [
                  116.052297,
                  28.619599
                ],
                [
                  116.05179,
                  28.616271
                ],
                [
                  116.048185,
                  28.610337
                ],
                [
                  116.043914,
                  28.609411
                ],
                [
                  116.041953,
                  28.607404
                ],
                [
                  116.041221,
                  28.600823
                ],
                [
                  116.040534,
                  28.599578
                ],
                [
                  116.033446,
                  28.598266
                ],
                [
                  116.024522,
                  28.592582
                ],
                [
                  116.020229,
                  28.589349
                ],
                [
                  116.017705,
                  28.585721
                ],
                [
                  116.009355,
                  28.582797
                ],
                [
                  116.005254,
                  28.583935
                ],
                [
                  116.00353,
                  28.5874
                ],
                [
                  116.003947,
                  28.589253
                ],
                [
                  116.000138,
                  28.588037
                ],
                [
                  115.999789,
                  28.586763
                ],
                [
                  115.995902,
                  28.585702
                ],
                [
                  115.992769,
                  28.588413
                ],
                [
                  115.989434,
                  28.589793
                ],
                [
                  115.984138,
                  28.589948
                ],
                [
                  115.983642,
                  28.58739
                ],
                [
                  115.98158,
                  28.585238
                ],
                [
                  115.977411,
                  28.585258
                ],
                [
                  115.976048,
                  28.587593
                ],
                [
                  115.972554,
                  28.588375
                ],
                [
                  115.969861,
                  28.587236
                ],
                [
                  115.967078,
                  28.588085
                ],
                [
                  115.965219,
                  28.590565
                ],
                [
                  115.960734,
                  28.591212
                ],
                [
                  115.95936,
                  28.593846
                ],
                [
                  115.955709,
                  28.59569
                ],
                [
                  115.953613,
                  28.594252
                ],
                [
                  115.94603,
                  28.591424
                ],
                [
                  115.940914,
                  28.59098
                ],
                [
                  115.937466,
                  28.593412
                ],
                [
                  115.937489,
                  28.592631
                ],
                [
                  115.928666,
                  28.594059
                ],
                [
                  115.925455,
                  28.597137
                ],
                [
                  115.922255,
                  28.597562
                ],
                [
                  115.918964,
                  28.59376
                ],
                [
                  115.914942,
                  28.59291
                ],
                [
                  115.914987,
                  28.590073
                ],
                [
                  115.912947,
                  28.589398
                ],
                [
                  115.912215,
                  28.587217
                ],
                [
                  115.910367,
                  28.587419
                ],
                [
                  115.909263,
                  28.583289
                ],
                [
                  115.906761,
                  28.583964
                ],
                [
                  115.903742,
                  28.583134
                ],
                [
                  115.904542,
                  28.591106
                ],
                [
                  115.903854,
                  28.59374
                ],
                [
                  115.900237,
                  28.593943
                ],
                [
                  115.895899,
                  28.597156
                ],
                [
                  115.891471,
                  28.599665
                ],
                [
                  115.891234,
                  28.60256
                ],
                [
                  115.892823,
                  28.603863
                ],
                [
                  115.89075,
                  28.604335
                ],
                [
                  115.890029,
                  28.607867
                ],
                [
                  115.887888,
                  28.610414
                ],
                [
                  115.884496,
                  28.607761
                ],
                [
                  115.880744,
                  28.609092
                ],
                [
                  115.87671,
                  28.609334
                ],
                [
                  115.87102,
                  28.610675
                ],
                [
                  115.868912,
                  28.609816
                ],
                [
                  115.86347,
                  28.611562
                ],
                [
                  115.861555,
                  28.614274
                ],
                [
                  115.854602,
                  28.612662
                ],
                [
                  115.848777,
                  28.608716
                ],
                [
                  115.845757,
                  28.609797
                ],
                [
                  115.843334,
                  28.61409
                ],
                [
                  115.839481,
                  28.614795
                ],
                [
                  115.832923,
                  28.617149
                ],
                [
                  115.826647,
                  28.607356
                ],
                [
                  115.822196,
                  28.5987
                ],
                [
                  115.820877,
                  28.588954
                ],
                [
                  115.818838,
                  28.576977
                ],
                [
                  115.818489,
                  28.565607
                ],
                [
                  115.818861,
                  28.562412
                ],
                [
                  115.817463,
                  28.556813
                ],
                [
                  115.814263,
                  28.539899
                ],
                [
                  115.810815,
                  28.536017
                ],
                [
                  115.809215,
                  28.532937
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "adcode": 360123,
          "name": "安义县",
          "center": [
            115.553109,
            28.841334
          ],
          "centroid": [
            115.588492,
            28.829446
          ],
          "childrenNum": 0,
          "level": "district",
          "parent": {
            "adcode": 360100
          },
          "subFeatureIndex": 7,
          "acroutes": [
            100000,
            360000,
            360100
          ]
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  115.759941,
                  28.89309
                ],
                [
                  115.757056,
                  28.895082
                ],
                [
                  115.755648,
                  28.897737
                ],
                [
                  115.75487,
                  28.904896
                ],
                [
                  115.750814,
                  28.910861
                ],
                [
                  115.742915,
                  28.916431
                ],
                [
                  115.740537,
                  28.918827
                ],
                [
                  115.738363,
                  28.928465
                ],
                [
                  115.734182,
                  28.930418
                ],
                [
                  115.729585,
                  28.93114
                ],
                [
                  115.726802,
                  28.929966
                ],
                [
                  115.726306,
                  28.920866
                ],
                [
                  115.723726,
                  28.917826
                ],
                [
                  115.719647,
                  28.916816
                ],
                [
                  115.714486,
                  28.91849
                ],
                [
                  115.708041,
                  28.921607
                ],
                [
                  115.700649,
                  28.920751
                ],
                [
                  115.69488,
                  28.922982
                ],
                [
                  115.683128,
                  28.924531
                ],
                [
                  115.678677,
                  28.923011
                ],
                [
                  115.67702,
                  28.923656
                ],
                [
                  115.674372,
                  28.927773
                ],
                [
                  115.666361,
                  28.928937
                ],
                [
                  115.663882,
                  28.93339
                ],
                [
                  115.664626,
                  28.936632
                ],
                [
                  115.671646,
                  28.940989
                ],
                [
                  115.674091,
                  28.941672
                ],
                [
                  115.678384,
                  28.940729
                ],
                [
                  115.681877,
                  28.943114
                ],
                [
                  115.682857,
                  28.946865
                ],
                [
                  115.680694,
                  28.948442
                ],
                [
                  115.682542,
                  28.951664
                ],
                [
                  115.681077,
                  28.954963
                ],
                [
                  115.678046,
                  28.954049
                ],
                [
                  115.675905,
                  28.949356
                ],
                [
                  115.675263,
                  28.946173
                ],
                [
                  115.671623,
                  28.944201
                ],
                [
                  115.668434,
                  28.943855
                ],
                [
                  115.666338,
                  28.947587
                ],
                [
                  115.660919,
                  28.948779
                ],
                [
                  115.656885,
                  28.945461
                ],
                [
                  115.65249,
                  28.947817
                ],
                [
                  115.647318,
                  28.945884
                ],
                [
                  115.645808,
                  28.94271
                ],
                [
                  115.644355,
                  28.941951
                ],
                [
                  115.643465,
                  28.944067
                ],
                [
                  115.638462,
                  28.947385
                ],
                [
                  115.635431,
                  28.948654
                ],
                [
                  115.629121,
                  28.947808
                ],
                [
                  115.624952,
                  28.949298
                ],
                [
                  115.622946,
                  28.951241
                ],
                [
                  115.621808,
                  28.958213
                ],
                [
                  115.622923,
                  28.959156
                ],
                [
                  115.619284,
                  28.962867
                ],
                [
                  115.613267,
                  28.965156
                ],
                [
                  115.604388,
                  28.965839
                ],
                [
                  115.598371,
                  28.965608
                ],
                [
                  115.593931,
                  28.966752
                ],
                [
                  115.588455,
                  28.969041
                ],
                [
                  115.576973,
                  28.969512
                ],
                [
                  115.571226,
                  28.971118
                ],
                [
                  115.566787,
                  28.97456
                ],
                [
                  115.559744,
                  28.981223
                ],
                [
                  115.55322,
                  28.98949
                ],
                [
                  115.550358,
                  28.99225
                ],
                [
                  115.542527,
                  29.000988
                ],
                [
                  115.531327,
                  29.009715
                ],
                [
                  115.525321,
                  29.015011
                ],
                [
                  115.521152,
                  29.016856
                ],
                [
                  115.512814,
                  29.018471
                ],
                [
                  115.508126,
                  29.018029
                ],
                [
                  115.499799,
                  29.014828
                ],
                [
                  115.483618,
                  29.010292
                ],
                [
                  115.479156,
                  29.00761
                ],
                [
                  115.475551,
                  29.006188
                ],
                [
                  115.473973,
                  29.004169
                ],
                [
                  115.47297,
                  28.999892
                ],
                [
                  115.476091,
                  28.994009
                ],
                [
                  115.472441,
                  28.993595
                ],
                [
                  115.472351,
                  28.991202
                ],
                [
                  115.468688,
                  28.992192
                ],
                [
                  115.46808,
                  28.988731
                ],
                [
                  115.463438,
                  28.983943
                ],
                [
                  115.465398,
                  28.979415
                ],
                [
                  115.469117,
                  28.973444
                ],
                [
                  115.471134,
                  28.971214
                ],
                [
                  115.472046,
                  28.966387
                ],
                [
                  115.479123,
                  28.964492
                ],
                [
                  115.479855,
                  28.960992
                ],
                [
                  115.482199,
                  28.956396
                ],
                [
                  115.48532,
                  28.951866
                ],
                [
                  115.4887,
                  28.948423
                ],
                [
                  115.490514,
                  28.945375
                ],
                [
                  115.491821,
                  28.940845
                ],
                [
                  115.498199,
                  28.935333
                ],
                [
                  115.499303,
                  28.928975
                ],
                [
                  115.505354,
                  28.924425
                ],
                [
                  115.506256,
                  28.921799
                ],
                [
                  115.503867,
                  28.916527
                ],
                [
                  115.504081,
                  28.913747
                ],
                [
                  115.50745,
                  28.910159
                ],
                [
                  115.512532,
                  28.902067
                ],
                [
                  115.513118,
                  28.899546
                ],
                [
                  115.512149,
                  28.896621
                ],
                [
                  115.519304,
                  28.895409
                ],
                [
                  115.522594,
                  28.892282
                ],
                [
                  115.523326,
                  28.886797
                ],
                [
                  115.521377,
                  28.883063
                ],
                [
                  115.524769,
                  28.876442
                ],
                [
                  115.526335,
                  28.870869
                ],
                [
                  115.530403,
                  28.863227
                ],
                [
                  115.530313,
                  28.860359
                ],
                [
                  115.528284,
                  28.857539
                ],
                [
                  115.522256,
                  28.852321
                ],
                [
                  115.51874,
                  28.847903
                ],
                [
                  115.517828,
                  28.842493
                ],
                [
                  115.514842,
                  28.841867
                ],
                [
                  115.514335,
                  28.838719
                ],
                [
                  115.51047,
                  28.837766
                ],
                [
                  115.507675,
                  28.833212
                ],
                [
                  115.505805,
                  28.832721
                ],
                [
                  115.495461,
                  28.84334
                ],
                [
                  115.493771,
                  28.844148
                ],
                [
                  115.491619,
                  28.837448
                ],
                [
                  115.487348,
                  28.829428
                ],
                [
                  115.489681,
                  28.823073
                ],
                [
                  115.484903,
                  28.818721
                ],
                [
                  115.48212,
                  28.810872
                ],
                [
                  115.48479,
                  28.804786
                ],
                [
                  115.484272,
                  28.801752
                ],
                [
                  115.481624,
                  28.797062
                ],
                [
                  115.477286,
                  28.79684
                ],
                [
                  115.467945,
                  28.79502
                ],
                [
                  115.465691,
                  28.79319
                ],
                [
                  115.466863,
                  28.789183
                ],
                [
                  115.466469,
                  28.78745
                ],
                [
                  115.459866,
                  28.787295
                ],
                [
                  115.45857,
                  28.785176
                ],
                [
                  115.464148,
                  28.783336
                ],
                [
                  115.461432,
                  28.779214
                ],
                [
                  115.459697,
                  28.77406
                ],
                [
                  115.457499,
                  28.771998
                ],
                [
                  115.453736,
                  28.766093
                ],
                [
                  115.451663,
                  28.766266
                ],
                [
                  115.450953,
                  28.768222
                ],
                [
                  115.453015,
                  28.771131
                ],
                [
                  115.453184,
                  28.773212
                ],
                [
                  115.451133,
                  28.774002
                ],
                [
                  115.44711,
                  28.771719
                ],
                [
                  115.442953,
                  28.774176
                ],
                [
                  115.440102,
                  28.771208
                ],
                [
                  115.440902,
                  28.767249
                ],
                [
                  115.442378,
                  28.766469
                ],
                [
                  115.444868,
                  28.760601
                ],
                [
                  115.438705,
                  28.759975
                ],
                [
                  115.44195,
                  28.754984
                ],
                [
                  115.445736,
                  28.745984
                ],
                [
                  115.448339,
                  28.741744
                ],
                [
                  115.449127,
                  28.737784
                ],
                [
                  115.44693,
                  28.735037
                ],
                [
                  115.453161,
                  28.732339
                ],
                [
                  115.460181,
                  28.733303
                ],
                [
                  115.461669,
                  28.728098
                ],
                [
                  115.463686,
                  28.724908
                ],
                [
                  115.467246,
                  28.722634
                ],
                [
                  115.469804,
                  28.722826
                ],
                [
                  115.473398,
                  28.7246
                ],
                [
                  115.474728,
                  28.730238
                ],
                [
                  115.477038,
                  28.731558
                ],
                [
                  115.483393,
                  28.729024
                ],
                [
                  115.489061,
                  28.734777
                ],
                [
                  115.494605,
                  28.735269
                ],
                [
                  115.497929,
                  28.734835
                ],
                [
                  115.505794,
                  28.732204
                ],
                [
                  115.511732,
                  28.731423
                ],
                [
                  115.514808,
                  28.73178
                ],
                [
                  115.518177,
                  28.733958
                ],
                [
                  115.521005,
                  28.738661
                ],
                [
                  115.52665,
                  28.73948
                ],
                [
                  115.532882,
                  28.734488
                ],
                [
                  115.535597,
                  28.733013
                ],
                [
                  115.540803,
                  28.732628
                ],
                [
                  115.545772,
                  28.733409
                ],
                [
                  115.55091,
                  28.732917
                ],
                [
                  115.553513,
                  28.731375
                ],
                [
                  115.559496,
                  28.729419
                ],
                [
                  115.560184,
                  28.728224
                ],
                [
                  115.557446,
                  28.726836
                ],
                [
                  115.556634,
                  28.724118
                ],
                [
                  115.554719,
                  28.721824
                ],
                [
                  115.553919,
                  28.71899
                ],
                [
                  115.549198,
                  28.715077
                ],
                [
                  115.546076,
                  28.708214
                ],
                [
                  115.546076,
                  28.706778
                ],
                [
                  115.548544,
                  28.70512
                ],
                [
                  115.54966,
                  28.699586
                ],
                [
                  115.553153,
                  28.696415
                ],
                [
                  115.554291,
                  28.693686
                ],
                [
                  115.554505,
                  28.686571
                ],
                [
                  115.553705,
                  28.683679
                ],
                [
                  115.548206,
                  28.676245
                ],
                [
                  115.546899,
                  28.673275
                ],
                [
                  115.544161,
                  28.658395
                ],
                [
                  115.543733,
                  28.649319
                ],
                [
                  115.539766,
                  28.64278
                ],
                [
                  115.541761,
                  28.638189
                ],
                [
                  115.545626,
                  28.635198
                ],
                [
                  115.547068,
                  28.632353
                ],
                [
                  115.54202,
                  28.631668
                ],
                [
                  115.542989,
                  28.628388
                ],
                [
                  115.541727,
                  28.627201
                ],
                [
                  115.547057,
                  28.62121
                ],
                [
                  115.542617,
                  28.617535
                ],
                [
                  115.541975,
                  28.615952
                ],
                [
                  115.53873,
                  28.614428
                ],
                [
                  115.537468,
                  28.611533
                ],
                [
                  115.53509,
                  28.610983
                ],
                [
                  115.532431,
                  28.612846
                ],
                [
                  115.529963,
                  28.612151
                ],
                [
                  115.529163,
                  28.609517
                ],
                [
                  115.525693,
                  28.607732
                ],
                [
                  115.524487,
                  28.6042
                ],
                [
                  115.528251,
                  28.602203
                ],
                [
                  115.524859,
                  28.602184
                ],
                [
                  115.525163,
                  28.596674
                ],
                [
                  115.523405,
                  28.595603
                ],
                [
                  115.52149,
                  28.596684
                ],
                [
                  115.527665,
                  28.59099
                ],
                [
                  115.528904,
                  28.585904
                ],
                [
                  115.527552,
                  28.582507
                ],
                [
                  115.553468,
                  28.58022
                ],
                [
                  115.556668,
                  28.582025
                ],
                [
                  115.556578,
                  28.583578
                ],
                [
                  115.561558,
                  28.586493
                ],
                [
                  115.560679,
                  28.588269
                ],
                [
                  115.561761,
                  28.590874
                ],
                [
                  115.559417,
                  28.596934
                ],
                [
                  115.558865,
                  28.600196
                ],
                [
                  115.563711,
                  28.601904
                ],
                [
                  115.564747,
                  28.605175
                ],
                [
                  115.564127,
                  28.608726
                ],
                [
                  115.572432,
                  28.60917
                ],
                [
                  115.575035,
                  28.611003
                ],
                [
                  115.578156,
                  28.614679
                ],
                [
                  115.580072,
                  28.622812
                ],
                [
                  115.581604,
                  28.62369
                ],
                [
                  115.583846,
                  28.628774
                ],
                [
                  115.588173,
                  28.631774
                ],
                [
                  115.592015,
                  28.635642
                ],
                [
                  115.594325,
                  28.641786
                ],
                [
                  115.597233,
                  28.645992
                ],
                [
                  115.605605,
                  28.653129
                ],
                [
                  115.610641,
                  28.655752
                ],
                [
                  115.617785,
                  28.657913
                ],
                [
                  115.621425,
                  28.658019
                ],
                [
                  115.624287,
                  28.659938
                ],
                [
                  115.624737,
                  28.663226
                ],
                [
                  115.624163,
                  28.666409
                ],
                [
                  115.626135,
                  28.677893
                ],
                [
                  115.630371,
                  28.681519
                ],
                [
                  115.637673,
                  28.68633
                ],
                [
                  115.637256,
                  28.692587
                ],
                [
                  115.635555,
                  28.69734
                ],
                [
                  115.636276,
                  28.69949
                ],
                [
                  115.641391,
                  28.70242
                ],
                [
                  115.644445,
                  28.70753
                ],
                [
                  115.647127,
                  28.707366
                ],
                [
                  115.648501,
                  28.711829
                ],
                [
                  115.645786,
                  28.718846
                ],
                [
                  115.648794,
                  28.721169
                ],
                [
                  115.650101,
                  28.727742
                ],
                [
                  115.648783,
                  28.733813
                ],
                [
                  115.643014,
                  28.741687
                ],
                [
                  115.634574,
                  28.748894
                ],
                [
                  115.634,
                  28.752604
                ],
                [
                  115.636738,
                  28.757826
                ],
                [
                  115.643453,
                  28.765881
                ],
                [
                  115.65222,
                  28.781969
                ],
                [
                  115.655352,
                  28.790358
                ],
                [
                  115.657482,
                  28.801117
                ],
                [
                  115.65933,
                  28.805807
                ],
                [
                  115.659364,
                  28.811537
                ],
                [
                  115.660524,
                  28.8138
                ],
                [
                  115.667015,
                  28.814638
                ],
                [
                  115.669831,
                  28.810978
                ],
                [
                  115.667736,
                  28.807868
                ],
                [
                  115.668141,
                  28.804362
                ],
                [
                  115.664164,
                  28.803187
                ],
                [
                  115.664152,
                  28.799373
                ],
                [
                  115.661944,
                  28.798584
                ],
                [
                  115.661482,
                  28.794731
                ],
                [
                  115.662665,
                  28.792564
                ],
                [
                  115.665786,
                  28.792603
                ],
                [
                  115.668829,
                  28.796667
                ],
                [
                  115.668524,
                  28.798709
                ],
                [
                  115.672085,
                  28.799489
                ],
                [
                  115.675533,
                  28.805162
                ],
                [
                  115.679477,
                  28.809659
                ],
                [
                  115.6867,
                  28.815552
                ],
                [
                  115.687916,
                  28.817103
                ],
                [
                  115.691849,
                  28.816631
                ],
                [
                  115.693122,
                  28.818441
                ],
                [
                  115.690542,
                  28.81926
                ],
                [
                  115.692333,
                  28.822746
                ],
                [
                  115.694824,
                  28.8234
                ],
                [
                  115.700424,
                  28.820926
                ],
                [
                  115.703173,
                  28.82082
                ],
                [
                  115.704863,
                  28.823111
                ],
                [
                  115.706351,
                  28.828003
                ],
                [
                  115.705393,
                  28.829591
                ],
                [
                  115.705923,
                  28.832942
                ],
                [
                  115.702001,
                  28.834637
                ],
                [
                  115.703049,
                  28.837303
                ],
                [
                  115.702835,
                  28.840163
                ],
                [
                  115.708649,
                  28.842117
                ],
                [
                  115.713911,
                  28.841482
                ],
                [
                  115.716435,
                  28.837448
                ],
                [
                  115.720683,
                  28.836293
                ],
                [
                  115.729078,
                  28.832085
                ],
                [
                  115.72936,
                  28.82964
                ],
                [
                  115.727196,
                  28.827396
                ],
                [
                  115.726678,
                  28.82367
                ],
                [
                  115.729179,
                  28.826963
                ],
                [
                  115.733394,
                  28.828917
                ],
                [
                  115.736064,
                  28.827127
                ],
                [
                  115.737766,
                  28.823901
                ],
                [
                  115.742769,
                  28.826077
                ],
                [
                  115.747343,
                  28.82342
                ],
                [
                  115.752098,
                  28.824845
                ],
                [
                  115.754115,
                  28.826741
                ],
                [
                  115.753879,
                  28.829331
                ],
                [
                  115.748346,
                  28.833019
                ],
                [
                  115.748932,
                  28.838979
                ],
                [
                  115.751242,
                  28.843224
                ],
                [
                  115.747648,
                  28.844659
                ],
                [
                  115.747219,
                  28.848298
                ],
                [
                  115.750442,
                  28.848192
                ],
                [
                  115.752696,
                  28.852937
                ],
                [
                  115.754983,
                  28.856239
                ],
                [
                  115.756774,
                  28.856913
                ],
                [
                  115.761924,
                  28.855046
                ],
                [
                  115.763254,
                  28.856124
                ],
                [
                  115.760425,
                  28.860465
                ],
                [
                  115.758307,
                  28.865114
                ],
                [
                  115.749022,
                  28.871216
                ],
                [
                  115.746701,
                  28.87392
                ],
                [
                  115.745608,
                  28.87854
                ],
                [
                  115.749349,
                  28.884795
                ],
                [
                  115.757158,
                  28.884622
                ],
                [
                  115.764301,
                  28.883342
                ],
                [
                  115.761653,
                  28.886104
                ],
                [
                  115.75958,
                  28.885911
                ],
                [
                  115.758487,
                  28.88849
                ],
                [
                  115.759896,
                  28.890222
                ],
                [
                  115.759941,
                  28.89309
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "adcode": 360124,
          "name": "进贤县",
          "center": [
            116.267671,
            28.365681
          ],
          "centroid": [
            116.309318,
            28.436387
          ],
          "childrenNum": 0,
          "level": "district",
          "parent": {
            "adcode": 360100
          },
          "subFeatureIndex": 8,
          "acroutes": [
            100000,
            360000,
            360100
          ]
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  116.096208,
                  28.268294
                ],
                [
                  116.098113,
                  28.264461
                ],
                [
                  116.098541,
                  28.253415
                ],
                [
                  116.101166,
                  28.249494
                ],
                [
                  116.104377,
                  28.247858
                ],
                [
                  116.111352,
                  28.246086
                ],
                [
                  116.113843,
                  28.243453
                ],
                [
                  116.116006,
                  28.237179
                ],
                [
                  116.117403,
                  28.235939
                ],
                [
                  116.130395,
                  28.230314
                ],
                [
                  116.142362,
                  28.229113
                ],
                [
                  116.14999,
                  28.226188
                ],
                [
                  116.155815,
                  28.223119
                ],
                [
                  116.160796,
                  28.216863
                ],
                [
                  116.164266,
                  28.20866
                ],
                [
                  116.164672,
                  28.2031
                ],
                [
                  116.163016,
                  28.195739
                ],
                [
                  116.163985,
                  28.192688
                ],
                [
                  116.167726,
                  28.188794
                ],
                [
                  116.176041,
                  28.183214
                ],
                [
                  116.181991,
                  28.180569
                ],
                [
                  116.192526,
                  28.179164
                ],
                [
                  116.204583,
                  28.179833
                ],
                [
                  116.209022,
                  28.178438
                ],
                [
                  116.212346,
                  28.174824
                ],
                [
                  116.21762,
                  28.166763
                ],
                [
                  116.221969,
                  28.164341
                ],
                [
                  116.224144,
                  28.162064
                ],
                [
                  116.225496,
                  28.158556
                ],
                [
                  116.22829,
                  28.157839
                ],
                [
                  116.2298,
                  28.160252
                ],
                [
                  116.230048,
                  28.168498
                ],
                [
                  116.232876,
                  28.1737
                ],
                [
                  116.233226,
                  28.188823
                ],
                [
                  116.235851,
                  28.195003
                ],
                [
                  116.24002,
                  28.198877
                ],
                [
                  116.244189,
                  28.201841
                ],
                [
                  116.257981,
                  28.210025
                ],
                [
                  116.264224,
                  28.212757
                ],
                [
                  116.274376,
                  28.218209
                ],
                [
                  116.287638,
                  28.222518
                ],
                [
                  116.29494,
                  28.225239
                ],
                [
                  116.297272,
                  28.224542
                ],
                [
                  116.301667,
                  28.221318
                ],
                [
                  116.30685,
                  28.219245
                ],
                [
                  116.31049,
                  28.219691
                ],
                [
                  116.312867,
                  28.225637
                ],
                [
                  116.311887,
                  28.234816
                ],
                [
                  116.313228,
                  28.240306
                ],
                [
                  116.314817,
                  28.243056
                ],
                [
                  116.323155,
                  28.246241
                ],
                [
                  116.330163,
                  28.245534
                ],
                [
                  116.333792,
                  28.243685
                ],
                [
                  116.340778,
                  28.237934
                ],
                [
                  116.344395,
                  28.235852
                ],
                [
                  116.35217,
                  28.232618
                ],
                [
                  116.356282,
                  28.226644
                ],
                [
                  116.357522,
                  28.219071
                ],
                [
                  116.35724,
                  28.214713
                ],
                [
                  116.359257,
                  28.207604
                ],
                [
                  116.36133,
                  28.206452
                ],
                [
                  116.364215,
                  28.20649
                ],
                [
                  116.366942,
                  28.207856
                ],
                [
                  116.37057,
                  28.211033
                ],
                [
                  116.376238,
                  28.221453
                ],
                [
                  116.37608,
                  28.233209
                ],
                [
                  116.380531,
                  28.237324
                ],
                [
                  116.385737,
                  28.24051
                ],
                [
                  116.3959,
                  28.244808
                ],
                [
                  116.401613,
                  28.244557
                ],
                [
                  116.412272,
                  28.247703
                ],
                [
                  116.427056,
                  28.248758
                ],
                [
                  116.432757,
                  28.248487
                ],
                [
                  116.444938,
                  28.249088
                ],
                [
                  116.451023,
                  28.247994
                ],
                [
                  116.459947,
                  28.248042
                ],
                [
                  116.463846,
                  28.249843
                ],
                [
                  116.466978,
                  28.252341
                ],
                [
                  116.468803,
                  28.255303
                ],
                [
                  116.473063,
                  28.268333
                ],
                [
                  116.476815,
                  28.282977
                ],
                [
                  116.477626,
                  28.2871
                ],
                [
                  116.480274,
                  28.29372
                ],
                [
                  116.483654,
                  28.296671
                ],
                [
                  116.489908,
                  28.300745
                ],
                [
                  116.496658,
                  28.303658
                ],
                [
                  116.498742,
                  28.306164
                ],
                [
                  116.502438,
                  28.312541
                ],
                [
                  116.505356,
                  28.321684
                ],
                [
                  116.505413,
                  28.326966
                ],
                [
                  116.502438,
                  28.343276
                ],
                [
                  116.502472,
                  28.348083
                ],
                [
                  116.50512,
                  28.353335
                ],
                [
                  116.507216,
                  28.355608
                ],
                [
                  116.511159,
                  28.362446
                ],
                [
                  116.512207,
                  28.365415
                ],
                [
                  116.517988,
                  28.373616
                ],
                [
                  116.520591,
                  28.378122
                ],
                [
                  116.523746,
                  28.380597
                ],
                [
                  116.528703,
                  28.386031
                ],
                [
                  116.536388,
                  28.392954
                ],
                [
                  116.543442,
                  28.397682
                ],
                [
                  116.551724,
                  28.402554
                ],
                [
                  116.554946,
                  28.403889
                ],
                [
                  116.557268,
                  28.403453
                ],
                [
                  116.559825,
                  28.407059
                ],
                [
                  116.556513,
                  28.409099
                ],
                [
                  116.559566,
                  28.411796
                ],
                [
                  116.557786,
                  28.415189
                ],
                [
                  116.560851,
                  28.417896
                ],
                [
                  116.55907,
                  28.419926
                ],
                [
                  116.560096,
                  28.422178
                ],
                [
                  116.562642,
                  28.4224
                ],
                [
                  116.563938,
                  28.426914
                ],
                [
                  116.564197,
                  28.431427
                ],
                [
                  116.561144,
                  28.433699
                ],
                [
                  116.56369,
                  28.434588
                ],
                [
                  116.565482,
                  28.43684
                ],
                [
                  116.564456,
                  28.43797
                ],
                [
                  116.565482,
                  28.440232
                ],
                [
                  116.564468,
                  28.444068
                ],
                [
                  116.56218,
                  28.443392
                ],
                [
                  116.559623,
                  28.444986
                ],
                [
                  116.558338,
                  28.451171
                ],
                [
                  116.559656,
                  28.458428
                ],
                [
                  116.559037,
                  28.468186
                ],
                [
                  116.556997,
                  28.472331
                ],
                [
                  116.552636,
                  28.478562
                ],
                [
                  116.551408,
                  28.4843
                ],
                [
                  116.55222,
                  28.487962
                ],
                [
                  116.554068,
                  28.492076
                ],
                [
                  116.55489,
                  28.496887
                ],
                [
                  116.554135,
                  28.499417
                ],
                [
                  116.551059,
                  28.503802
                ],
                [
                  116.539216,
                  28.513547
                ],
                [
                  116.536152,
                  28.518617
                ],
                [
                  116.532298,
                  28.523243
                ],
                [
                  116.523036,
                  28.531132
                ],
                [
                  116.513266,
                  28.540623
                ],
                [
                  116.509402,
                  28.544794
                ],
                [
                  116.497706,
                  28.552691
                ],
                [
                  116.493649,
                  28.557575
                ],
                [
                  116.489074,
                  28.56219
                ],
                [
                  116.484466,
                  28.569574
                ],
                [
                  116.479057,
                  28.575809
                ],
                [
                  116.473953,
                  28.583656
                ],
                [
                  116.465784,
                  28.600698
                ],
                [
                  116.463508,
                  28.608292
                ],
                [
                  116.46273,
                  28.615132
                ],
                [
                  116.456071,
                  28.622696
                ],
                [
                  116.454865,
                  28.625523
                ],
                [
                  116.451226,
                  28.627616
                ],
                [
                  116.445445,
                  28.633144
                ],
                [
                  116.443124,
                  28.635999
                ],
                [
                  116.442414,
                  28.640243
                ],
                [
                  116.442932,
                  28.643281
                ],
                [
                  116.447586,
                  28.649908
                ],
                [
                  116.449096,
                  28.652782
                ],
                [
                  116.448296,
                  28.656389
                ],
                [
                  116.447856,
                  28.66501
                ],
                [
                  116.447034,
                  28.666669
                ],
                [
                  116.441828,
                  28.667267
                ],
                [
                  116.440341,
                  28.670478
                ],
                [
                  116.440521,
                  28.672619
                ],
                [
                  116.444003,
                  28.678347
                ],
                [
                  116.444127,
                  28.682049
                ],
                [
                  116.442459,
                  28.685134
                ],
                [
                  116.446752,
                  28.690823
                ],
                [
                  116.447383,
                  28.695653
                ],
                [
                  116.446493,
                  28.701187
                ],
                [
                  116.435315,
                  28.713169
                ],
                [
                  116.429693,
                  28.717429
                ],
                [
                  116.421974,
                  28.721082
                ],
                [
                  116.418166,
                  28.72166
                ],
                [
                  116.412295,
                  28.724031
                ],
                [
                  116.406098,
                  28.724465
                ],
                [
                  116.392193,
                  28.727819
                ],
                [
                  116.388892,
                  28.730103
                ],
                [
                  116.386537,
                  28.736174
                ],
                [
                  116.382176,
                  28.739913
                ],
                [
                  116.379922,
                  28.744047
                ],
                [
                  116.380497,
                  28.75008
                ],
                [
                  116.377319,
                  28.751727
                ],
                [
                  116.370097,
                  28.751718
                ],
                [
                  116.372328,
                  28.747064
                ],
                [
                  116.370345,
                  28.744828
                ],
                [
                  116.366209,
                  28.743508
                ],
                [
                  116.363178,
                  28.741195
                ],
                [
                  116.360102,
                  28.742737
                ],
                [
                  116.35813,
                  28.746177
                ],
                [
                  116.35813,
                  28.753269
                ],
                [
                  116.353172,
                  28.754107
                ],
                [
                  116.344969,
                  28.751544
                ],
                [
                  116.33964,
                  28.75034
                ],
                [
                  116.326377,
                  28.742602
                ],
                [
                  116.320112,
                  28.738468
                ],
                [
                  116.317566,
                  28.737427
                ],
                [
                  116.306016,
                  28.732676
                ],
                [
                  116.297892,
                  28.727366
                ],
                [
                  116.292258,
                  28.723116
                ],
                [
                  116.291526,
                  28.719684
                ],
                [
                  116.293126,
                  28.714508
                ],
                [
                  116.295977,
                  28.7094
                ],
                [
                  116.298557,
                  28.706064
                ],
                [
                  116.298084,
                  28.703365
                ],
                [
                  116.292912,
                  28.697706
                ],
                [
                  116.291864,
                  28.695643
                ],
                [
                  116.291807,
                  28.691141
                ],
                [
                  116.285272,
                  28.685144
                ],
                [
                  116.282737,
                  28.683553
                ],
                [
                  116.278973,
                  28.677575
                ],
                [
                  116.27228,
                  28.67366
                ],
                [
                  116.266939,
                  28.671491
                ],
                [
                  116.265689,
                  28.666139
                ],
                [
                  116.268663,
                  28.663525
                ],
                [
                  116.268855,
                  28.661674
                ],
                [
                  116.271199,
                  28.65717
                ],
                [
                  116.271244,
                  28.653071
                ],
                [
                  116.275086,
                  28.650477
                ],
                [
                  116.279852,
                  28.649589
                ],
                [
                  116.282095,
                  28.643629
                ],
                [
                  116.284269,
                  28.641507
                ],
                [
                  116.288067,
                  28.64141
                ],
                [
                  116.294264,
                  28.645278
                ],
                [
                  116.295098,
                  28.642057
                ],
                [
                  116.292393,
                  28.633414
                ],
                [
                  116.290692,
                  28.631118
                ],
                [
                  116.291188,
                  28.6275
                ],
                [
                  116.289543,
                  28.623101
                ],
                [
                  116.28463,
                  28.619705
                ],
                [
                  116.281418,
                  28.618962
                ],
                [
                  116.277351,
                  28.616319
                ],
                [
                  116.27139,
                  28.614573
                ],
                [
                  116.264889,
                  28.614949
                ],
                [
                  116.260426,
                  28.616705
                ],
                [
                  116.255502,
                  28.617274
                ],
                [
                  116.244539,
                  28.614534
                ],
                [
                  116.240325,
                  28.606188
                ],
                [
                  116.23771,
                  28.602753
                ],
                [
                  116.232448,
                  28.600891
                ],
                [
                  116.231017,
                  28.599067
                ],
                [
                  116.228505,
                  28.588867
                ],
                [
                  116.220989,
                  28.582073
                ],
                [
                  116.214408,
                  28.573859
                ],
                [
                  116.211986,
                  28.569362
                ],
                [
                  116.201,
                  28.559912
                ],
                [
                  116.194228,
                  28.554679
                ],
                [
                  116.180413,
                  28.546502
                ],
                [
                  116.168458,
                  28.541067
                ],
                [
                  116.161945,
                  28.537427
                ],
                [
                  116.151241,
                  28.52809
                ],
                [
                  116.147308,
                  28.51939
                ],
                [
                  116.145731,
                  28.514126
                ],
                [
                  116.145111,
                  28.496703
                ],
                [
                  116.144559,
                  28.490734
                ],
                [
                  116.144784,
                  28.485691
                ],
                [
                  116.141877,
                  28.475384
                ],
                [
                  116.139263,
                  28.469664
                ],
                [
                  116.134023,
                  28.461664
                ],
                [
                  116.129054,
                  28.4555
                ],
                [
                  116.125155,
                  28.452079
                ],
                [
                  116.121246,
                  28.450717
                ],
                [
                  116.11684,
                  28.450504
                ],
                [
                  116.112209,
                  28.452089
                ],
                [
                  116.109347,
                  28.455915
                ],
                [
                  116.099273,
                  28.461693
                ],
                [
                  116.093403,
                  28.461626
                ],
                [
                  116.089977,
                  28.464428
                ],
                [
                  116.082845,
                  28.465703
                ],
                [
                  116.079475,
                  28.468003
                ],
                [
                  116.080321,
                  28.470872
                ],
                [
                  116.077999,
                  28.473104
                ],
                [
                  116.072805,
                  28.473056
                ],
                [
                  116.069086,
                  28.471626
                ],
                [
                  116.063024,
                  28.46636
                ],
                [
                  116.061345,
                  28.466022
                ],
                [
                  116.05712,
                  28.467964
                ],
                [
                  116.053931,
                  28.468602
                ],
                [
                  116.046979,
                  28.468891
                ],
                [
                  116.04503,
                  28.468486
                ],
                [
                  116.043204,
                  28.466196
                ],
                [
                  116.039655,
                  28.454959
                ],
                [
                  116.035857,
                  28.450717
                ],
                [
                  116.029356,
                  28.44774
                ],
                [
                  116.027936,
                  28.441923
                ],
                [
                  116.029052,
                  28.437854
                ],
                [
                  116.033345,
                  28.431041
                ],
                [
                  116.036004,
                  28.423705
                ],
                [
                  116.036004,
                  28.415808
                ],
                [
                  116.036815,
                  28.406025
                ],
                [
                  116.035903,
                  28.401839
                ],
                [
                  116.033345,
                  28.398678
                ],
                [
                  116.02895,
                  28.391533
                ],
                [
                  116.026809,
                  28.386022
                ],
                [
                  116.025987,
                  28.381322
                ],
                [
                  116.027012,
                  28.375318
                ],
                [
                  116.030843,
                  28.366769
                ],
                [
                  116.034111,
                  28.362649
                ],
                [
                  116.040229,
                  28.357339
                ],
                [
                  116.043734,
                  28.35143
                ],
                [
                  116.055047,
                  28.347561
                ],
                [
                  116.058821,
                  28.347377
                ],
                [
                  116.059993,
                  28.34523
                ],
                [
                  116.060264,
                  28.340935
                ],
                [
                  116.05863,
                  28.33132
                ],
                [
                  116.058957,
                  28.329539
                ],
                [
                  116.062585,
                  28.32775
                ],
                [
                  116.066484,
                  28.327682
                ],
                [
                  116.072084,
                  28.329394
                ],
                [
                  116.074157,
                  28.328553
                ],
                [
                  116.072839,
                  28.325263
                ],
                [
                  116.074044,
                  28.321674
                ],
                [
                  116.073875,
                  28.315695
                ],
                [
                  116.074889,
                  28.31346
                ],
                [
                  116.07836,
                  28.31048
                ],
                [
                  116.080456,
                  28.310073
                ],
                [
                  116.094203,
                  28.310644
                ],
                [
                  116.097065,
                  28.310344
                ],
                [
                  116.09951,
                  28.307693
                ],
                [
                  116.100175,
                  28.30479
                ],
                [
                  116.098586,
                  28.301374
                ],
                [
                  116.094766,
                  28.299129
                ],
                [
                  116.091814,
                  28.296478
                ],
                [
                  116.090743,
                  28.294291
                ],
                [
                  116.091048,
                  28.2883
                ],
                [
                  116.092073,
                  28.283819
                ],
                [
                  116.096546,
                  28.272689
                ],
                [
                  116.096208,
                  28.268294
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "name": "湾里管理局"
        },
        "geometry": {
          "coordinates": [
            [
              [
                115.72348281915043,
                28.71735686583986
              ],
              [
                115.71792428296402,
                28.713032754963223
              ],
              [
                115.7136745827712,
                28.708870304660635
              ],
              [
                115.71758586354343,
                28.701565721286443
              ],
              [
                115.72233783978004,
                28.695819228754118
              ],
              [
                115.7316754399937,
                28.69510058472534
              ],
              [
                115.73577349816304,
                28.70085158491989
              ],
              [
                115.73886708345424,
                28.707446608144423
              ],
              [
                115.73836324355165,
                28.712596947400016
              ],
              [
                115.7339595342624,
                28.716207357390573
              ],
              [
                115.72888755540288,
                28.716941854240034
              ],
              [
                115.72348281915043,
                28.71735686583986
              ]
            ]
          ],
          "type": "Polygon"
        },
        "id": 9
      }
    ]
  }
export default nanchang